import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  PaperClipOutlined,
  DownloadOutlined,
  UploadOutlined,
  CopyOutlined,
  EditOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import {
  Form,
  Input,
  Table,
  Collapse as AntCollapse,
  Descriptions,
  Modal as AntModal,
  Spin,
  Flex,
  Select,
  InputNumber,
  Empty,
  Modal,
  DatePicker,
  Radio,
  Tooltip,
  message,
  Upload,
  Popover,
  Timeline,
} from "antd";
import Dragger from "antd/es/upload/Dragger";
import { UploadFile } from "antd/es/upload/interface";
import { Button as AntButton } from "antd";
import { AllowedFileTypes } from "../../fileAccess";
import {
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import dayjs from "dayjs";
import {
  Badge,
  Button,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
  UncontrolledDropdown,
} from "reactstrap";
import { nanoid } from "nanoid";
import Swal from "sweetalert2";
import usersApis from "../../api/master/users";
import dispatchApis from "../../api/dispatch/dispatch";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { fetchSequenceAccess } from "../../store/slices/misc/sequenceAccess";
import { formatCurrency, formatDecimal } from "../../utils/Utils";
import PdfGenerator from "./SellerToBuyerDispatchPDF";
import axios from "axios";
import { TimePicker } from "antd";
import miscService from "../../api/misc/misc";
import EmailCreationModal from "../EmailCreationModal";
import { useForm, FormProvider, useFormContext } from "react-hook-form";
import CropperComponent from "../components/CropperComponent";
import SignatureModal from "../purchase-orders/SignatureModal";
import Misc from "../masters/Misc";
import FormInput from "../form-components/InputComponent";
import FormSelect from "../form-components/SelectComponent";
import FormDatePicker from "../form-components/DatePicker";
import FormTimePicker from "../form-components/FormTimePicker";
import invoiceApis from "../../api/Invoice/invoice";
import sequenceApis from "../../api/master/sequence";
import GRNApprovalDrawer from "./GRNApprovalDrawer";
import ImageUploadCropper from "../components/ImageUploadCropper";
import { Link } from "react-router-dom";
// import { _ } from "ag-grid-community";

const { beforeUpload: beforeUploadMisc } = Misc;

const { Panel } = AntCollapse;
function ApprovalComponent({ dispatchNumber, previousPath, extra }: any) {
  const pdfBlobData: any = useRef(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [shareOptionsToggle, setShareOptionsToggle] = useState(false);
  const { data: currentUser } = useSelector((state: any) => state.currentUser);
  const [disableAccept, setDisableAccept] = useState(false);
  const dispatch: any = useDispatch();
  const { data: sequenceAccess } = useSelector(
    (state: any) => state.sequenceAccess
  );
  const navigate = useNavigate();
  const [showSubmitBtn, setShowSubmitBtn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [tab, setTab] = useState("1");
  const [driverTab, setDriverTab] = useState("1");
  const [OriginalData, setOriginalData] = useState<any>({});
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [sm, setSm] = useState(false);
  const [materialData, setMaterialData] = useState<any>({});
  const [bankDetailsVisible, setBankDetailsVisible] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState<any>("");
  const [dataSource, setDataSource] = useState<any>([]);
  const [currency, setCurrency] = useState<any>({
    currencyFormat: "",
    currencySymbol: "",
  });
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [readOnly, setReadOnly] = useState<any>(true);
  const [currentUserId, setCurrentUserId] = useState<any>(null);
  const [attachments, setAttachments] = useState<any>([]);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [showCropModel, setShowCropModel] = useState<boolean>(false);
  const [showSignatureModel, setShowSignatureModel] = useState<boolean>(false);
  const [invoiceSignature, setInvoiceSignature] = useState<any>({});

  const [approvals, setApprovals] = useState({
    open: false,
    data: [],
  });
  const [isStrictApproval, setIsStrictApproval] = useState<boolean>(false);

  // Signature states for approve/reject
  const [grnSignature, setGrnSignature] = useState<any>([]); // For GRN signature from API
  const [signature, setSignature] = useState({ // For approve/reject signature modal
    isActive: false,
    label: "Authorised Signatory",
    image: null as string | null,
  });

  const [isModalApproveVisible, setIsModalApproveVisible] = useState(false);
  const [approveRecord, setApproveRecord] = useState<any>(null);
  const [activeSignatureContext, setActiveSignatureContext] = useState<
    "APPROVE" | "REJECT" | null
  >(null);
  const [isModalRejectedVisible, setIsModalRejectedVisible] = useState(false);
  const [rejectRecord, setRejectRecord] = useState<any>(null);
  const [isStrictMode, setIsStrictMode] = useState<boolean>(false);
  const [approverIds, setApproverIds] = useState<any>([]);
  const { data: accessibility } = useSelector(
    (state: any) => state.accessibility
  );
  const [allowedActions, setAllowedActions] = useState<any>({
    add: 0,
    view: 0,
    edit: 0,
    approve: 0,
    reject: 0,
    cancel: 0,
  });

  const methods = useForm({
    mode: "onChange",
  });
  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = methods;
  const siteIdWatch = watch("siteId");

  useEffect(() => {
    if (accessibility) {
      try {
        const grnAccess = accessibility["Dispatch"];
        if (grnAccess) {
          const { add, view, edit, approve, reject, cancel } = grnAccess;
          setAllowedActions({ add, view, edit, approve, reject, cancel });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }, [accessibility]);

  useEffect(() => {
    dispatch(fetchSequenceAccess());
  }, [dispatch]);

  useEffect(() => {
    if (isModalVisible == false) {
      setDisableAccept(false);
    }
  }, [isModalVisible]);

  // Note: Remarks column is always visible when GRN is Pending
  // Individual row fields are enabled/disabled based on receivedQty < dispatchedQty condition

  const beforeUpload = (file: UploadFile) => {
    const isAllowedType = Object.values(AllowedFileTypes)
      .filter((value) => typeof value === "string")
      .includes(file.type as AllowedFileTypes);
    if (!isAllowedType) {
      message.error(
        "You can only upload PDF, JPG, JPEG, PNG, GIF, DOC, DOCX files!"
      );
      return Upload.LIST_IGNORE;
    }
    if (file.size && file.size / 1024 / 1024 >= 2) {
      message.error("File must be smaller than 5MB!");
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  const handleAttachmentChange = (info: { fileList: UploadFile[] }) => {
    setFileList(info.fileList);
  };

  // Prevent automatic upload - just store files
  const customRequest = ({ onSuccess }: any) => {
    // Just mark as success without making API call
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    isRemarks = false,
    ...restProps
  }: any) => {
    const receivedQty = record?.recievedQuantity || 0;
    const dispatchedQty = Number(record?.quantityDispatched) || 0;
    const showRemarks = isRemarks && receivedQty < dispatchedQty;

    return (
      <td {...restProps}>
        {editing ? (
          isRemarks ? (
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues[`recievedQuantity_${record.lineNo}`] !==
                currentValues[`recievedQuantity_${record.lineNo}`]
              }
            >
              {({ getFieldValue }) => {
                const currentReceivedQty = Number(getFieldValue(`recievedQuantity_${record.lineNo}`)) || 0;
                const currentDispatchedQty = Number(record?.quantityDispatched) || 0;
                const shouldShowRemarks = currentReceivedQty < currentDispatchedQty;

                // Only show remarks input field if receivedQty < dispatchedQty
                if (!shouldShowRemarks) {
                  return <div className="align-left">-</div>;
                }

                return (
                  <Form.Item
                    name={dataIndex + `_${record.lineNo}`}
                    style={{ margin: 0 }}
                    rules={[
                      {
                        required: true,
                        message: `${title} is required when Received Qty < Dispatched Qty`,
                      },
                    ]}
                    initialValue={record["remarks"] || ""}
                  >
                    <Input
                      className="w-100"
                      placeholder="Enter remarks (required)"
                    />
                  </Form.Item>
                );
              }}
            </Form.Item>
          ) : (
            <Form.Item
              name={dataIndex + `_${record.lineNo}`}
              style={{ margin: 0 }}
              rules={[
                {
                  required: true,
                  message: `${title} is required`,
                },
                {
                  type: "number",
                  min: 0.01,
                  max: Number(record?.quantityDispatched),
                  message: `${title} must be > 0 and <= ${Number(
                    record?.quantityDispatched
                  )}`,
                },
              ]}
              initialValue={Number(record["quantityDispatched"])}
            >
              <InputNumber
                defaultValue={Number(record["quantityDispatched"])}
                className="w-100"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value: any) => value!.replace(/\$\s?|(,*)/g, "")}
                onKeyPress={(event) => {
                  const regex = /^[0-9\b\.]+$/;
                  if (!regex.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                step={0.01}
              />
            </Form.Item>
          )
        ) : (
          children
        )}
      </td>
    );
  };

  const columns = [
    {
      title: "#",
      key: "#",
      width: 50,
      fixed: "left",
      render: (text: any, record: any, index: number) => index + 1,
    },
    {
      title: "Material Name",
      dataIndex: "materialName",
      key: "materialName",
      width: 200,
      fixed: "left",
      render: (material: any) => <div className="align-left">{material}</div>,
    },
    {
      title: "Need By Date",
      dataIndex: "needByDate",
      key: "needByDate",
      width: 150,
      render: (text: any) => dayjs(text).format("DD-MMM-YYYY"),
    },
    {
      title: "Dispatched Qty",
      dataIndex: "quantityDispatched",
      key: "quantityDispatched",
      width: 150,
      render: (text: any, record: any) => (
        <div className="align-left">{Number(text) + " " + record?.uom}</div>
      ),
    },
    {
      title: "Received Qty",
      dataIndex: "recievedQuantity",
      key: "recievedQuantity",
      width: 150,
      editable: true,
      hidden: false,
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
      width: 200,
      editable: true,
      isRemarks: true,
      hidden: false,
      render: (text: any, record: any) => {
        // Show remarks only if receivedQty < dispatchedQty, otherwise show dash
        const receivedQty = record?.recievedQuantity || 0;
        const dispatchedQty = Number(record?.quantityDispatched) || 0;
        if (receivedQty < dispatchedQty) {
          return <div className="align-left">{text || "-"}</div>;
        }
        return <div className="align-left">-</div>;
      },
    },
    {
      title: "GRN Qty",
      dataIndex: "grnQuantity",
      key: "grnQuantity",
      width: 150,
      render: (text: any, record: any) => (
        <div className="align-left">{Number(text) + " " + record?.uom}</div>
      ),
      hidden: true,
    },
    {
      title: "GRN Remarks",
      dataIndex: "grnRemarks",
      key: "grnRemarks",
      width: 200,
      hidden: false,
      render: (text: any, record: any) => {
        // Show grnRemarks if it exists in the response
        if (record?.grnRemarks) {
          return <div className="align-left">{record.grnRemarks}</div>;
        }
        return <div className="align-left">-</div>;
      },
    },
    {
      title: "Rate",
      dataIndex: "unitPrice",
      key: "unitPrice",
      width: 150,
      render: (text: any, record: any) => (
        <p className="justify-end">
          {formatCurrency(Number(text), currency?.currencyCode)}
        </p>
      ),
    },
    {
      title: "Basic Amount",
      dataIndex: "basicAmount",
      key: "basicAmount",
      width: 150,
      render: (text: any) => <div>{text}</div>,
    },
    {
      title: "Net Amount",
      dataIndex: "netAmount",
      key: "netAmount",
      width: 150,
      render: (text: any) => <div>{text}</div>,
    },
    {
      title: "CGST",
      children: [
        {
          title: "%",
          dataIndex: "cgstPercentage",
          key: "cgstPercentage",
          width: 100,
          render: (text: any, record: any) =>
            `${Number(record?.sgst) && Number(record?.cgst)
              ? Number(text) + "%"
              : "N/A"
            }`,
        },
        {
          title: "Amount",
          dataIndex: "cgst",
          key: "cgst",
          width: 150,
          render: (text: any, record: any) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {Number(record?.sgst) && Number(record?.cgst)
                  ? formatCurrency(text, "INR")
                  : "N/A"}
              </span>
            </div>
          ),
        },
      ],
    },
    {
      title: "SGST",
      children: [
        {
          title: "%",
          dataIndex: "sgstPercentage",
          key: "sgstPercentage",
          width: 100,
          render: (text: any, record: any) =>
            `${Number(record?.sgst) && Number(record?.cgst)
              ? Number(text) + "%"
              : "N/A"
            }`,
        },
        {
          title: "Amount",
          dataIndex: "sgst",
          key: "sgst",
          width: 150,
          render: (text: any, record: any) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {Number(record?.sgst) && Number(record?.cgst)
                  ? formatCurrency(text, "INR")
                  : "N/A"}
              </span>
            </div>
          ),
        },
      ],
    },
    {
      title: "IGST",
      children: [
        {
          title: "%",
          dataIndex: "igstPercentage",
          key: "igstPercentage",
          width: 100,
          render: (text: any, record: any) =>
            `${!Number(record?.sgst) && !Number(record?.cgst)
              ? Number(text) + "%"
              : "N/A"
            }`,
        },
        {
          title: "Amount",
          dataIndex: "igst",
          key: "igst",
          width: 150,
          render: (text: any, record: any) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {!Number(record?.sgst) && !Number(record?.cgst)
                  ? formatCurrency(text, "INR")
                  : "N/A"}
              </span>
            </div>
          ),
        },
      ],
    },
    {
      title: "Gross Total",
      dataIndex: "grossTotal",
      key: "grossTotal",
      width: 150,
      render: (text: any) => <div>{text}</div>,
    },
  ];

  // Remarks column is always visible when GRN is Pending
  // Individual row remarks fields are conditionally enabled/required based on receivedQty < dispatchedQty

  const mergedColumns: any = columns.map((col) => {
    if (
      ["basicAmount", "netAmount", "additionalCharges", "grossTotal"].includes(
        col?.dataIndex as string
      )
    ) {
      return {
        ...col,
        render: (text: any) => (
          <p className="justify-end">
            {formatCurrency(Number(text), currency?.currencyCode)}
          </p>
        ),
      };
    } else if ((col.children?.length as number) > 0) {
      return {
        ...col,
        // children: col?.children?.map((child: any) => {
        //   if (child?.title == "Amount") {
        //     return {
        //       ...child,
        //       render: (text: any) => (
        //         <p className="justify-end">
        //           {formatCurrency(
        //             Number(text),
        //             currency?.currencyCode
        //           )}
        //         </p>
        //       ),
        //     };
        //   } else {
        //     return child;
        //   }
        // }),
      };
    }
    if (
      materialData?.needByDateType != "Line Level" &&
      col?.dataIndex == "needByDate"
    ) {
      return {
        ...col,
        hidden: true,
      };
    }
    if (OriginalData?.grnStatus == "Accepted" || OriginalData?.approvalStatus === "Pending") {
      if (col?.dataIndex == "recievedQuantity") {
        return {
          ...col,
          editable: false,
          hidden: true,
        };
      } else if (col?.dataIndex == "grnQuantity") {
        return {
          ...col,
          hidden: false,
        };
      } else if (col?.dataIndex == "grnRemarks") {
        return {
          ...col,
          hidden: false,
        };
      } else if (col?.dataIndex == "remarks") {
        return {
          ...col,
          editable: false,
          hidden: true,
        };
      }
    }
    // Always show remarks column when GRN is Pending (field will be enabled/disabled per row)
    // No need to hide the column - individual rows will handle their own remarks field state
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: any) => ({
        record,
        inputType: col.isRemarks ? "text" : "number",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: OriginalData?.grnStatus == "Pending" ? true : false,
        isRemarks: col.isRemarks || false,
      }),
    };
  });

  const fetchCurrentUser = async () => {
    try {
      const data = await usersApis.getCurrentUser();
      if (data) {
        setCurrentUserId(data?.id);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };

  const TriggerEmail = async (emailData: any, _methods: any) => {
    try {
      const formData = new FormData();
      formData.append("msgType", "grnConfirmation");
      formData.append("logo", currentUser?.orgLogo);
      formData.append("email", emailData?.to);
      formData.append("cc", emailData?.cc);
      formData.append("bcc", emailData?.bcc);
      if (emailData?.attachments?.length > 0) {
        emailData?.attachments?.forEach((attachment: any, index: number) => {
          if (!attachment) {
            return;
          }
          let file: any = null;
          if (index == 0) {
            file = new File(
              [pdfBlobData.current],
              OriginalData?.dispatchId + ".pdf",
              {
                type: "application/pdf",
              }
            );
          } else {
            file = attachment?.originFileObj;
          }
          formData.append(`files`, file);
        });
      }
      const response: any = await dispatchApis.sendGrnEmailNotification(
        dispatchNumber,
        formData
      );
      const { data, status } = response;
      if (status) {
        Swal.fire("Success", "Email has been sent successfully", "success");
        _methods.reset();
        setShowEmailModal(false);
      }
    } catch (error) {
      console.log(error);
      setShowEmailModal(false);
    }
  };

  const fetchDispatchData = async () => {
    try {
      const response = await dispatchApis.fetchDispatch(dispatchNumber);
      const { status, message, data } = response;
      if (status) {
        let responseData: any = data;
        const isStrict =
          responseData?.isStrictApproval === true || responseData?.isStrictApproval === 1;

        setIsStrictMode(isStrict);

        if (responseData?.grnApprovals) {
          const processedApprovals = responseData.grnApprovals.map((approval: any) => ({
            ...approval,
            level: approval.level?.toLowerCase() || approval.level,
            status: approval.status?.toLowerCase() || approval.status
          }));
          responseData.grnApprovals = processedApprovals;

          // Filter pending approvals
          let ids = processedApprovals
            ?.filter((item: any) => item?.status?.toLowerCase() !== "approved")
            ?.map((item: any) => item?.id);
          setApproverIds(ids);
        }

        if (data?.lineItems) {
          setDataSource(data?.lineItems);
        }
        // Reset signature and attachments before setting new ones
        setGrnSignature({});
        setAttachments([]);

        if (data?.dms?.length > 0) {
          const dms = data?.dms;
          const _signature = dms?.find(
            (item: any) =>
              item.moduleFileType == "signature" && item.module == "grn"
          );
          if (_signature) {
            setGrnSignature({
              docId: _signature?.docId,
              fileName: _signature?.fileName,
              image: _signature?.filePath,
              moduleFileType: _signature?.moduleFileType,
              module: _signature?.module,
              label: data?.grnSignatureLabel,
              isActive: true,
            });
          }
          const _attachments = dms?.filter(
            (item: any) => (item.moduleFileType == "attachment" || item.moduleFileType == "attachments") && item.module == "grn"
          );
          if (_attachments && _attachments.length > 0) {
            setAttachments(
              _attachments.map((attachment: any) => ({
                docId: attachment?.docId,
                name: attachment?.fileName,
                link: attachment?.filePath,
                moduleFileType: attachment?.moduleFileType,
                module: attachment?.module,
                label: "attachment",
                isActive: true,
              }))
            );
          }
        }
        setCurrency({
          currencyCode: data?.currencyCode,
          currency: data?.currencyName,
          currencySymbol: data?.currencySymbol,
          currencyFormat: data?.currencyFormat,
        });
        if (
          [
            "Pending Approval",
            "Approval Rejected",
            "To be Dispatched",
            "Partially Dispatched",
          ].includes(data.invoiceStatus) &&
          data?.invoiceType != "commercial"
        ) {
          setReadOnly(false);
        } else {
          setReadOnly(true);
        }
        setMaterialData(data);
        setOriginalData(data);
        setShowSubmitBtn(false);
        setIsLoading(false);
        await fetchDMSData("buyerOrgLogo", data?.orgId);
        await fetchDMSData("sellerOrgLogo", data?.supplierId);
        await fetchDMSData("termsAndConditions", data?.invoiceNumber);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchHtmlContentFromUrl = async (url: string) => {
    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "text/html",
        },
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const fetchDMSData = async (type: string, id: any) => {
    try {
      const queryObj: any = {};
      switch (type) {
        case "buyerOrgLogo":
          queryObj["moduleFileType"] = "org logo";
          queryObj["module"] = "orgs";
          queryObj["orgId"] = id;
          break;
        case "sellerOrgLogo":
          queryObj["moduleFileType"] = "org logo";
          queryObj["module"] = "orgs";
          queryObj["orgId"] = id;
          break;
        case "termsAndConditions":
          queryObj["moduleFileType"] = "termsAndConditions";
          queryObj["module"] = "invoice";
          queryObj["invoiceNumber"] = id;
          break;
        default:
          return;
      }
      const _response = await miscService.getByQuery(queryObj);
      const { status, response: dmsData } = _response;
      if (status && dmsData?.length > 0) {
        const item = dmsData[0];
        switch (type) {
          case "buyerOrgLogo":
            let orgLogo = item?.filePath;
            setOriginalData((pre: any) => ({ ...pre, buyerOrgLogo: orgLogo }));
            break;
          case "sellerOrgLogo":
            let sellerOrgLogo = item?.filePath;
            setOriginalData((pre: any) => ({
              ...pre,
              sellerOrgLogo: sellerOrgLogo,
            }));
            break;
          case "termsAndConditions":
            const _termsAndConditions: any = await fetchHtmlContentFromUrl(
              item?.filePath
            );
            setTermsAndConditions(_termsAndConditions);
            break;
          default:
            break;
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCurrentUser();
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  useEffect(() => {
    if (dispatchNumber) {
      setIsLoading(true);
      fetchDispatchData();
    }
  }, [dispatchNumber]);

  useEffect(() => {
    // Set default tab based on GRN status
    // Pending GRN: show only Delivery Info (tab 2)
    // Delivered GRN: show General Info (tab 1)
    if (OriginalData?.grnStatus === "Accepted" || OriginalData?.approvalStatus === "Pending") {
      setDriverTab("1");
    } else if (OriginalData?.grnStatus === "Pending") {
      setDriverTab("2");
    }
  }, [OriginalData?.grnStatus]);

  const ShowBillingAddress = ({ address }: any) => {
    if (!address) return <></>;
    const {
      deliveryLocationName,
      addressLine1,
      addressLine2,
      city,
      state,
      countryInfo,
      pincode,
      district,
    } = address;
    const { cin, gstin, pan, phoneNumber } = OriginalData?.orgDetails;
    return (
      <ul>
        <li>
          <strong style={{ color: "#2263b3" }}>
            {address?.deliveryLocationName}
          </strong>
        </li>
        <li>{addressLine1}</li>
        <li>{addressLine2}</li>
        <li>
          {city},{district}, {state}, {countryInfo} - {pincode}
        </li>
        <li>
          <strong>GSTIN</strong> : {gstin}
        </li>
        <li>
          <strong>CIN</strong> : {cin}
        </li>
        <li>
          <strong>PAN</strong> : {pan}
        </li>
        <li>
          <strong>Phone</strong> : {phoneNumber}
        </li>
      </ul>
    );
  };
  const ShowDeliveryAddress = ({ type, address }: any) => {
    if (!address) return <></>;
    const {
      deliveryLocationName,
      addressLine1,
      addressLine2,
      city,
      state,
      countryInfo,
      pincode,
      district,
    } = address;

    return (
      <ul>
        <li>
          <strong style={{ color: "#2263b3" }}>
            {address?.deliveryLocationName}
          </strong>
        </li>
        <li>
          {addressLine1},{addressLine2}
        </li>
        <li>
          {city},{district}, {state}, {countryInfo} - {pincode}
        </li>
        <li>
          <strong>Contact Person</strong> : {address?.contactPersonName}
        </li>
        <li>
          <strong>Mobile Number</strong> : {address?.mobileNumber}
        </li>
      </ul>
    );
  };

  function base64ToFile(base64String: string, fileName: string) {
    const byteString = atob(base64String.split(",")[1]);
    const mimeString = base64String.split(",")[0].split(":")[1].split(";")[0];
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([arrayBuffer], { type: mimeString });
    return new File([blob], fileName, { type: mimeString });
  }

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      message.success("Link copied to clipboard!");
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        message.success("Link copied to clipboard!");
      } catch (error) {
        message.error("Failed to copy link");
      }
      document.body.removeChild(textArea);
    }
  };

  const acceptGRN = async (
    grnId: any,
    driverInfo: any,
    grnDate: any = null,
    gateEntryNo: any = null,
    autoRelease?: boolean,
    grnApprovalHierarchy?: any[],
    isStrictApproval?: boolean
  ) => {
    try {
      const rows = await form.validateFields();
      const dispatchLines: any = [];
      dataSource.forEach((item: any) => {
        const quantityDispatched = rows[`recievedQuantity_` + item.lineNo];
        const receivedQty = Number(quantityDispatched) || 0;
        const dispatchedQty = Number(item?.quantityDispatched) || 0;

        const dispatchLine: any = {
          lineNo: item.lineNo,
          grnQuantity: quantityDispatched,
          grnStatus: "Accepted",
        };

        // Add grnRemarks if received qty < dispatched qty (optional field)
        if (receivedQty < dispatchedQty) {
          const remarks = rows[`remarks_` + item.lineNo];
          if (remarks && remarks.trim()) {
            dispatchLine.grnRemarks = remarks.trim();
          }
        }

        dispatchLines.push(dispatchLine);
      });
      const signatureLabel = invoiceSignature?.label;
      const _formData: any = new FormData();
      const filesData = [];

      // Add signature file if it exists
      if (invoiceSignature?.image) {
        const image = base64ToFile(invoiceSignature?.image, "signature.png");
        _formData.append("files", image);
        filesData.push({
          indexOfFileLocated: filesData.length,
          module: "grn",
          purpose: "signature",
          level: "Header Level",
          uniqueId: nanoid(4),
          action: "Create",
        });
      }

      // Add attachment files
      if (fileList && fileList.length > 0) {
        fileList.forEach((attachment: any) => {
          if (!attachment) {
            return;
          }
          const file = attachment?.originFileObj || attachment;
          _formData.append("files", file);
          filesData.push({
            indexOfFileLocated: filesData.length,
            module: "grn",
            purpose: "attachments",
            level: "Header Level",
            action: "Create",
          });
        });
      }

      _formData.append("grnSignatureLabel", JSON.stringify(signatureLabel));
      _formData.append("dispatchLines", JSON.stringify(dispatchLines));

      // Build driverInfo object with only fields that have values
      const driverInfoObj: any = {};
      if (driverInfo.name) driverInfoObj.name = driverInfo.name;
      if (driverInfo.dmrNo) driverInfoObj.dmrNo = driverInfo.dmrNo;
      if (driverInfo.email) driverInfoObj.email = driverInfo.email;
      if (driverInfo.mobile) driverInfoObj.mobile = driverInfo.mobile;
      if (driverInfo.ticketNo) driverInfoObj.ticketNo = driverInfo.ticketNo;
      if (
        driverInfo.netWeight !== undefined &&
        driverInfo.netWeight !== null &&
        driverInfo.netWeight !== ""
      )
        driverInfoObj.netWeight = driverInfo.netWeight;
      if (driverInfo.vehicleType)
        driverInfoObj.vehicleType = driverInfo.vehicleType;
      if (driverInfo.youTubeLink)
        driverInfoObj.youTubeLink = driverInfo.youTubeLink;
      if (driverInfo.vehicleInTime)
        driverInfoObj.vehicleInTime = driverInfo.vehicleInTime;
      if (driverInfo.vehicleNumber)
        driverInfoObj.vehicleNumber = driverInfo.vehicleNumber;
      if (driverInfo.vehicleOutTime)
        driverInfoObj.vehicleOutTime = driverInfo.vehicleOutTime;
      if (
        driverInfo.loadTruckWeight !== undefined &&
        driverInfo.loadTruckWeight !== null &&
        driverInfo.loadTruckWeight !== ""
      )
        driverInfoObj.loadTruckWeight = driverInfo.loadTruckWeight;
      if (
        driverInfo.emptyTruckWeight !== undefined &&
        driverInfo.emptyTruckWeight !== null &&
        driverInfo.emptyTruckWeight !== ""
      )
        driverInfoObj.emptyTruckWeight = driverInfo.emptyTruckWeight;
      if (
        driverInfo.netWeightInHouse !== undefined &&
        driverInfo.netWeightInHouse !== null &&
        driverInfo.netWeightInHouse !== ""
      )
        driverInfoObj.netWeightInHouse = driverInfo.netWeightInHouse;
      if (driverInfo.weighbridgeSlipNo)
        driverInfoObj.weighbridgeSlipNo = driverInfo.weighbridgeSlipNo;
      if (driverInfo.dharamKantaRecieptNo)
        driverInfoObj.dharamKantaRecieptNo = driverInfo.dharamKantaRecieptNo;
      if (
        driverInfo.loadTruckWeightInHouse !== undefined &&
        driverInfo.loadTruckWeightInHouse !== null &&
        driverInfo.loadTruckWeightInHouse !== ""
      )
        driverInfoObj.loadTruckWeightInHouse =
          driverInfo.loadTruckWeightInHouse;
      if (
        driverInfo.emptyTruckWeightInHouse !== undefined &&
        driverInfo.emptyTruckWeightInHouse !== null &&
        driverInfo.emptyTruckWeightInHouse !== ""
      )
        driverInfoObj.emptyTruckWeightInHouse =
          driverInfo.emptyTruckWeightInHouse;
      if (
        driverInfo.gateEntryId !== undefined &&
        driverInfo.gateEntryId !== null
      )
        driverInfoObj.gateEntryId = driverInfo.gateEntryId;
      if (
        driverInfo.gateEntryNo !== undefined &&
        driverInfo.gateEntryNo !== null
      )
        driverInfoObj.gateEntryNo = driverInfo.gateEntryNo;

      // Add gateEntryNo to driverInfo if it's provided from modal
      if (gateEntryNo) {
        driverInfoObj.gateEntryNo = gateEntryNo;
      }

      _formData.append("driverInfo", JSON.stringify(driverInfoObj));
      _formData.append("grnSequenceId", grnId);
      if (grnDate) _formData.append("grnCreatedDate", grnDate);
      if (gateEntryNo) _formData.append("gateEntryNo", gateEntryNo);

      // Add autoRelease to the payload
      if (autoRelease !== undefined) {
        _formData.append("autoRelease", String(autoRelease));
      }

      // Add grnApprovalHierarchy to the payload
      if (grnApprovalHierarchy && grnApprovalHierarchy.length > 0) {
        _formData.append("grnApprovalHierarchy", JSON.stringify(grnApprovalHierarchy));
      }

      // Add isStrictApproval to FormData
      if (isStrictApproval !== undefined) {
        _formData.append("isStrictApproval", String(isStrictApproval));
      }

      _formData.append("filesData", JSON.stringify(filesData));
      const response = await dispatchApis.acceptGrn(dispatchNumber, _formData);
      const { status, message, error } = response;
      if (status) {
        Swal.fire("GRN Accepted", "", "success");
        setFileList([]); // Reset file list after successful submission
        navigate("/pending-approvals-grn-list");
      } else {
        Swal.fire("Failed!", error + " : " + message, "error");
      }
    } catch (error) {
      console.log(error);
    }
    setDisableAccept(false);
  };

  const ShowSupplierBankInfo = () => {
    if (!OriginalData?.supplierDetails) return <></>;

    const { cin, gstin, pan, phoneNumber, bankDetails, address } =
      OriginalData?.supplierDetails || {};

    const { bankName, accountNumber, accountHolderName, branch, ifscCode } =
      bankDetails || {};

    const { city, stateInfo, countryInfo, pincode } = address || {};

    return (
      <Descriptions
        title="Supplier Bank Details "
        bordered
        column={1}
        size="small"
      >
        <Descriptions.Item label="GSTIN">{gstin}</Descriptions.Item>
        <Descriptions.Item label="CIN">{cin}</Descriptions.Item>
        <Descriptions.Item label="PAN">{pan}</Descriptions.Item>
        <Descriptions.Item label="Phone">{phoneNumber}</Descriptions.Item>
        <Descriptions.Item label="Bank Name">{bankName}</Descriptions.Item>
        <Descriptions.Item label="Account Number">
          {accountNumber}
        </Descriptions.Item>
        <Descriptions.Item label="Company Account Name">
          {accountHolderName}
        </Descriptions.Item>
        <Descriptions.Item label="Branch">{branch}</Descriptions.Item>
        <Descriptions.Item label="IFSC Code">{ifscCode}</Descriptions.Item>
        <Descriptions.Item label="City">{city}</Descriptions.Item>
        <Descriptions.Item label="State">
          {stateInfo?.stateName}
        </Descriptions.Item>
        <Descriptions.Item label="Country">
          {countryInfo?.countryName}
        </Descriptions.Item>
        <Descriptions.Item label="Pincode">{pincode}</Descriptions.Item>
      </Descriptions>
    );
  };

  const returnBillingDetails = () => {
    if (!OriginalData?.billingAddress) {
      return {};
    }
    const {
      deliveryLocationName,
      addressLine1,
      addressLine2,
      city,
      state,
      countryInfo,
      pincode,
      district,
    } = OriginalData?.billingAddress;
    const { cin, gstin, pan } = OriginalData?.orgDetails || {};
    return {
      name: OriginalData?.orgName || "",
      addressLine1: addressLine1,
      addressLine2: addressLine2,
      city: city,
      state: state,
      pincode: pincode,
      country: countryInfo,
      gstin: gstin || "",
      pan: pan || "",
      cin: cin || "",
      contactPersonName:
        OriginalData?.deliveryAddress?.contactPersonName || "N/A",
      mobileNumber: OriginalData?.deliveryAddress?.mobileNumber || "N/A",
    };
  };

  const returnSupplierDetails = () => {
    if (!OriginalData?.supplierDetails) {
      return {};
    }
    const { cin, gstin, pan, phoneNumber, bankDetails, address } =
      OriginalData?.supplierDetails || {};

    const { bankName, accountNumber, accountHolderName, branch, ifscCode } =
      bankDetails || {};

    const {
      city,
      stateInfo,
      countryInfo,
      pincode,
      addressline1,
      addressline2,
    } = address || {};
    return {
      name: OriginalData?.supplierName || "",
      addressLine1: addressline1 || "",
      addressLine2: addressline2 || "",
      city: city || "",
      state: stateInfo?.stateName || "",
      pincode: pincode || "",
      country: countryInfo?.countryName || "",
      gstin: gstin || "",
      pan: pan || "",
      cin: cin || "",
    };
  };
  const returnDispatchDetails = () => {
    let deliveryAddressString = "";
    if (
      OriginalData?.deliveryAddressType != "Line Level" &&
      OriginalData?.deliveryAddress
    ) {
      const {
        deliveryLocationName,
        addressLine1,
        addressLine2,
        city,
        state,
        countryInfo,
        pincode,
        district,
      } = OriginalData?.deliveryAddress;
      deliveryAddressString = [
        deliveryLocationName,
        addressLine1,
        addressLine2,
        city + ", " + state + ", " + district,
        countryInfo + ", " + pincode,
      ]
        ?.filter(Boolean)
        .join("\n");
    } else {
      deliveryAddressString = "Line Level";
    }
    const { driverInfo } = OriginalData;
    return {
      invoiceNumber: OriginalData?.invoiceId,
      invoiceDate: dayjs(OriginalData?.invoiceDate).format("DD-MMM-YYYY"),

      terms:
        materialData?.paymentTerms +
        (materialData?.advancePercentage
          ? `(${materialData?.advancePercentage}%)`
          : ""),
      customSONumber: "",
      ewayBillNumber: OriginalData?.ewbNo || "",
      placeofSupply: OriginalData?.deliveryAddress?.city || "",
      creditDays:
        materialData?.paymentTerms != "Cash and Carry"
          ? materialData?.creditDays
          : 0,
      deliveryAddressString,
      vehicleRefNo: driverInfo?.vehicleNumber || "",
      transporterName: driverInfo?.name || "",
      orderNumber: OriginalData?.orderId,
      orderDate: dayjs(OriginalData?.orderDate).format("DD-MMM-YYYY"),
      driverNumber: driverInfo?.mobile || "",

      totals: {
        taxableAmount: formatDecimal(materialData?.netAmount),
        cgst: formatDecimal(materialData?.cgst),
        sgst: formatDecimal(materialData?.sgst),
        igst: formatDecimal(materialData?.igst),
        total: formatDecimal(materialData?.grossTotal),
      },
      lines: dataSource?.map((item: any, index: any) => {
        let itemDescription = item?.materialName;
        if (item?.description) {
          itemDescription += "\t" + item?.description;
        }
        let deliveryAddressString = "";
        if (
          OriginalData?.deliveryAddressType == "Line Level" &&
          item?.deliveryAddress
        ) {
          const {
            deliveryLocationName,
            addressLine1,
            addressLine2,
            city,
            state,
            countryInfo,
            pincode,
            district,
          } = OriginalData?.deliveryAddress;
          deliveryAddressString = [
            deliveryLocationName,
            addressLine1,
            addressLine2,
            city,
            state,
            countryInfo,
            pincode,
            district,
          ]
            ?.filter(Boolean)
            .join(",");
          itemDescription += "\n\nDelivery Address: " + deliveryAddressString;
        }

        return {
          sno: index + 1,
          itemDescription,
          hsnSac: item?.hsnCode || "",
          rate: formatDecimal(item?.unitPrice),
          cgstPercentage: Number(item?.cgstPercentage),
          cgstAmount: formatDecimal(item?.cgst),
          sgstPercentage: Number(item?.sgstPercentage),
          sgstAmount: formatDecimal(item?.sgst),
          igstPercentage: Number(item?.igstPercentage),
          igstAmount: formatDecimal(item?.igst),
          taxableAmount: formatDecimal(item?.grossTotal),
          qty: Number(item?.quantityInvoiced),
          uom: item?.uomName,
        };
      }),
    };
  };

  const parseLevelNum = (level: any) => {
    if (!level && level !== 0) return NaN;
    const str = String(level).toLowerCase();

    // Handle various level formats: level1, Level2, L1, L2, etc.
    if (str.includes('level')) {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : NaN;
    } else if (str.startsWith('l')) {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : NaN;
    }
    return NaN;
  };

  const hasUserAlreadyApproved = materialData?.grnApprovals?.some(
    (a: any) =>
      a.id === currentUserId &&
      a.status?.toUpperCase() === "APPROVED"
  );
  const canUserApproveReject = useCallback(() => {
    // 1. Admin can Approve/Reject anytime - Buttons are always ENABLED
    if (currentUser?.genericRole?.toLowerCase() === "admin") {
      return true;
    }

    const approvals = materialData?.grnApprovals || [];

    // Find current user's approval entry
    const userApproval = approvals.find(
      (approval: any) => approval.id === currentUserId
    );

    if (!userApproval || userApproval.status?.toLowerCase() !== "pending") {
      return false;
    }

    const userLevelNum = parseLevelNum(userApproval.level ?? currentUser?.approvalLevel);

    // 2. Strict = 0 (Flexible mode)
    // Anyone in the approval list can approve at any time
    if (isStrictMode === false) {
      // In flexible mode, just check if user is in the approval list and pending
      return true;
    }

    // 3. Strict = 1 (Sequential mode)
    // Must follow the order. Level 2 cannot see buttons until Level 1 is "Approved"
    if (isStrictMode === true) {
      // Get all pending approvals sorted by level
      const pendingApprovals = approvals
        .filter((approval: any) => approval.status?.toLowerCase() === "pending")
        .sort((a: any, b: any) => {
          const aNum = parseLevelNum(a.level);
          const bNum = parseLevelNum(b.level);
          if (isNaN(aNum) || isNaN(bNum)) return 0;
          return aNum - bNum;
        });

      // If there are no pending approvals, user can't approve
      if (pendingApprovals.length === 0) return false;

      // Get the first pending approval (lowest level)
      const firstPending = pendingApprovals[0];
      const firstPendingLevelNum = parseLevelNum(firstPending.level);

      // Check if user is the first pending approver
      return userApproval.id === firstPending.id &&
        userLevelNum === firstPendingLevelNum;
    }

    return false;
  }, [currentUser, currentUserId, materialData?.grnApprovals, isStrictMode]);

  const getPendingStatusMessage = () => {
    const approvals = materialData?.grnApprovals || [];
    const pendingApprovals = approvals
      .filter((approval: any) => approval.status?.toLowerCase() === "pending")
      .sort((a: any, b: any) => {
        const aNum = parseLevelNum(a.level);
        const bNum = parseLevelNum(b.level);
        if (isNaN(aNum) || isNaN(bNum)) return 0;
        return aNum - bNum;
      });

    if (pendingApprovals?.length > 0) {
      if (!isStrictMode) {
        // Flexible mode - any approver can approve
        const approverNames = pendingApprovals.map((approval: any) => approval.name).join(", ");
        return `Status is pending. Any of these approvers can approve: ${approverNames}`;
      } else {
        // Strict mode - must follow sequence
        const nextApprover = pendingApprovals[0];
        const lvl = parseLevelNum(nextApprover.level);
        const levelText = !isNaN(lvl) ? `Level ${lvl}` : nextApprover.role || "";
        return `Status is pending. Waiting for ${nextApprover.name} (${levelText}) to approve first.`;
      }
    }

    return "Status is pending by other approvers";
  };

  const apiCallToRejectPr = async (dispatchNumber: any, rejectedReason: string) => {
    try {
      const files: File[] = [];
      if (signature.image) {
        files.push(dataURLToFile(signature.image as string, "signature.png"));
      }

      const res = await dispatchApis.reject(dispatchNumber, rejectedReason, files);
      const { status, message } = res;
      if (status) {
        Swal.fire("Approved!", "GRN has been Rejected", "success");
        navigate(-1);
      } else {
        Swal.fire("Failed!", message, "error");
      }
    } catch (error) {
      Swal.fire("Failed!", "Something went wrong", "error");
      setSignature({
        isActive: false,
        label: "Authorised Signatory",
        image: null,
      });
    }
  };

  const ApprovalTimelineContent = () => {
    const approvalsData = materialData?.grnApprovals;

    if (!approvalsData || approvalsData?.length === 0) {
      return <Badge color="outline-danger">No</Badge>;
    }

    return (
      <Popover
        content={
          <Timeline className="approval-timeline">
            {approvalsData?.map((approval: any, index: number) => {
              const isApproved = approval.status?.toLowerCase() == "approved";
              const isRejected = approval.status?.toLowerCase() == "rejected";
              return (
                <Timeline.Item
                  key={index}
                  dot={
                    isApproved ? (
                      <CheckCircleOutlined style={{ color: "green" }} />
                    ) : isRejected ? (
                      <CloseCircleOutlined style={{ color: "red" }} />
                    ) : undefined
                  }
                >
                  {approval?.name}
                  <div className="designation">{approval?.role}</div>
                  {approval?.approvalDate && (
                    <div className="designation">
                      {dayjs(approval?.approvalDate).format("DD-MMM-YYYY")}
                    </div>
                  )}
                </Timeline.Item>
              );
            })}
          </Timeline>
        }
        title={<span style={{ color: "#2263b3" }}>Approval Hierarchy</span>}
      >
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer"
        }}>
          <span
            style={{
              color: "#2263b3",
            }}
          >
            <Badge color="outline-success">Yes</Badge>
          </span>
          {isStrictMode && (
            <Badge
              color="warning"
              style={{
                fontSize: "11px",
                cursor: "pointer",
                marginLeft: "4px"
              }}
              title="Sequential approvals required, Approvals must follow the sequence"
            >
              Strict
            </Badge>
          )}
        </div>
      </Popover>
    );
  };

  const dataURLToFile = (dataUrl: string, fileName: string): File => {
    const arr = dataUrl.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/png";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
  };

  const handleApprove = async (id: string, files: File[] = []) => {
    try {
      const res = await dispatchApis.approve(Number(id), files);
      const { status, message } = res;
      if (status) {
        Swal.fire("Approved!", "GRN has been Approved", "success");
        navigate(-1);
      } else {
        Swal.fire("Failed!", message, "error");
      }
    } catch (error) {
      Swal.fire("Failed!", "Something went wrong", "error");
      setSignature({
        isActive: false,
        label: "Authorised Signatory",
        image: null,
      });
    }
  };

  const handleCancel = () => {
    setIsModalRejectedVisible(false);
    form.resetFields();
  };

  const openApproveConfirmSwal = () => {
    if (!signature.image) return;

    setIsModalApproveVisible(false);

    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve it!",
      cancelButtonText: "No, keep it",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const file = dataURLToFile(signature.image as string, "signature.png");
        await handleApprove(approveRecord, [file]);
      } else {
        setIsModalApproveVisible(true);
      }
    });
  };

  const openRejectConfirmSwal = async () => {
    try {
      await form.validateFields();

      if (!signature.image) {
        Swal.fire({
          icon: "info",
          title: "Signature Required",
          text: "Please add your signature before rejecting.",
        });
        return;
      }

      setIsModalRejectedVisible(false);

      Swal.fire({
        title: "Confirm Rejection?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Reject it!",
        cancelButtonText: "Cancel",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const values = form.getFieldsValue();
          await apiCallToRejectPr(rejectRecord, values.reason);
        } else {
          setIsModalRejectedVisible(true);
        }
      });
    } catch (e) {
      console.log("Validation failed:", e);
    }
  };

  return (
    <div className="card-inner card-inner-lg">
      {sm && mobileView && (
        <div className="toggle-overlay" onClick={() => setSm(!sm)}></div>
      )}
      <BlockHead size="lg">
        <BlockBetween>
          <BlockHeadContent>
            <BlockTitle tag="h4">
              <span>
                {OriginalData?.orderId} |{OriginalData?.invoiceId} |{" "}
                {OriginalData?.dispatchId}
              </span>
            </BlockTitle>
          </BlockHeadContent>

          <div className=" d-flex">
            {["Pending"].includes(OriginalData?.grnStatus) && !OriginalData?.grnCreatedDate ? (
              <div className="actions clearfix">
                <ul
                  className="m-auto d-flex align-items-center justify-content-center p-0"
                  style={{
                    flexDirection: "row-reverse",
                  }}
                >
                  <li className="pt-0 pb-0">
                    {disableAccept ? (
                      <Button color="success" type="button">
                        <Spinner size="sm" color="light" />
                      </Button>
                    ) : (
                      <Button
                        // color="success"
                        style={{
                          backgroundColor: "#046200",
                          borderColor: "#046200",
                        }}
                        type="button"
                        onClick={() => {
                          if (!invoiceSignature?.image) {
                            Swal.fire(
                              "Error",
                              "Signature is required",
                              "error"
                            );
                            return;
                          }
                          setIsModalVisible(true);
                        }}
                      >
                        Received
                      </Button>
                    )}
                  </li>
                </ul>
              </div>
            ) : (
              <li className="pt-0 pb-0">
                <Dropdown
                  isOpen={shareOptionsToggle}
                  toggle={() => {
                    setShareOptionsToggle(!shareOptionsToggle);
                  }}
                >
                  <DropdownToggle className="btn btn-white btn-outline-light">
                    <Icon name="share"></Icon>
                    <span>Send</span>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      onClick={() => {
                        setShowEmailModal(true);
                      }}
                    >
                      <Icon name="mail"></Icon>
                      <span>Send Mail</span>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </li>
            )}
            {
              <div className="paddingLeft10">
                <ul className="m-auto d-flex align-items-center justify-content-center p-0">
                  <li className="pt-0 pb-0">
                    <PdfGenerator
                      orgDetails1={returnSupplierDetails()}
                      orgDetails2={returnBillingDetails()}
                      HeaderDetails={returnDispatchDetails()}
                      buyerOrgLogo={OriginalData?.sellerOrgLogo}
                      hasIGST={Number(materialData?.igst) != 0}
                      TermsAndConditions={termsAndConditions}
                      grnNumber={(OriginalData?.grnId || OriginalData?.grnSequenceId || "")}
                      grnDate={
                        (OriginalData?.grnCreatedDate || OriginalData?.mrnDate)
                          ? dayjs(OriginalData?.grnCreatedDate || OriginalData?.mrnDate).format("DD-MMM-YYYY")
                          : ""
                      }
                      gateEntryNumber={(OriginalData?.gateEntryNo || OriginalData?.driverInfo?.gateEntryNo || "")}
                    />
                  </li>
                  <li className="pt-0 pb-0">
                    <Button
                      className="toggle"
                      color="primary"
                      onClick={async () => {
                        // Navigate to delivered list if GRN is accepted, otherwise use previousPath
                        const backPath =
                          OriginalData?.grnStatus === "Accepted" || OriginalData?.approvalStatus === "Pending"
                            ? "/pending-approvals-grn-list"
                            : previousPath || "/view-dispatch-list";
                        navigate(backPath, {
                          state: { ...extra?.previousState },
                        });
                      }}
                    >
                      <Icon name="arrow-left" />
                      <span>Back</span>
                    </Button>
                  </li>
                </ul>
              </div>
            }

            <ul className="nk-tb-actions ms-2">
              <li>
                <UncontrolledDropdown>
                  <DropdownToggle
                    tag="a"
                    className="dropdown-toggle btn btn-icon btn-trigger"
                  >
                    <Icon name="more-v"></Icon>
                  </DropdownToggle>
                  <DropdownMenu end>
                    <ul className="link-list-opt no-bdr">

                      {materialData?.approvalStatus?.toLowerCase() === "pending" &&
                        allowedActions?.approve == 1 &&
                        !hasUserAlreadyApproved &&
                        (

                          <>
                            {canUserApproveReject() ? (
                              <>
                                <li
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setApproveRecord(materialData?.dispatchNumber);
                                    setActiveSignatureContext("APPROVE");
                                    setIsModalApproveVisible(true);
                                    const dropdown = document.querySelector(
                                      ".dropdown-menu.show"
                                    );
                                    if (dropdown) {
                                      dropdown.classList.remove("show");
                                    }
                                  }}
                                >
                                  <Link to={`#`}>
                                    <Icon name="check" /> Approve
                                  </Link>
                                </li>
                                <li
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setRejectRecord(materialData?.dispatchNumber);
                                    setActiveSignatureContext("REJECT");
                                    setIsModalRejectedVisible(true);
                                    const dropdown = document.querySelector(
                                      ".dropdown-menu.show"
                                    );
                                    if (dropdown) {
                                      dropdown.classList.remove("show");
                                    }
                                  }}
                                >
                                  <Link to={`#`}>
                                    <Icon name="cross" /> Reject
                                  </Link>
                                </li>
                              </>
                            ) : (
                              <><li className="disabled" style={{ position: 'relative' }}>
                                <div
                                  className="d-flex align-items-center justify-content-between w-100"
                                  style={{
                                    padding: "8px 16px",
                                    opacity: 0.6,
                                    cursor: "not-allowed",
                                  }}
                                >
                                  <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                    <Icon name="check" />
                                    <span>Approve</span>
                                  </div>
                                  <Popover
                                    content={
                                      <div style={{ padding: "8px", maxWidth: "300px" }}>
                                        <p style={{ margin: 0 }}>{getPendingStatusMessage()}</p>
                                      </div>
                                    }
                                    title="Approval Status"
                                    trigger="hover"
                                  >
                                    <InfoCircleOutlined
                                      style={{
                                        fontSize: "16px",
                                        cursor: "pointer",
                                        color: "#2263b3",
                                        marginLeft: "8px"
                                      }}
                                    />
                                  </Popover>
                                </div>
                              </li>
                                <li className="disabled">
                                  <div
                                    className="d-flex align-items-center"
                                    style={{
                                      padding: "8px 16px",
                                      opacity: 0.6,
                                      cursor: "not-allowed",
                                      gap: "8px"
                                    }}
                                  >
                                    <Icon name="cross" />
                                    <span>Reject</span>
                                  </div>
                                </li>
                              </>
                            )}
                          </>
                        )}
                    </ul>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </li>
            </ul>
          </div>
        </BlockBetween>
      </BlockHead>
      {isLoading == true ? (
        <>
          <Flex align="center" gap="middle" className="pageLoader">
            <Spin size="large" className="m-auto" />
          </Flex>
        </>
      ) : (
        <div className="content clearfix">
          <ApproveCN
            isModalVisible={isModalVisible}
            setIsModalVisible={setIsModalVisible}
            accept={acceptGRN}
            extra={{
              showGrnId: sequenceAccess?.includes("GRN") ? false : true,
            }}
            originalData={OriginalData}
            approvals={approvals}
            setApprovals={setApprovals}
            isStrictApproval={isStrictApproval}
            setIsStrictApproval={setIsStrictApproval}
            siteIdWatch={siteIdWatch}
          />
          <AntCollapse defaultActiveKey={["1", "2", "3"]}>
            <Panel header="Driver Information" key="1">
              {/* Show tabs only for delivered GRN, hide for pending GRN */}
              {OriginalData?.grnStatus === "Accepted" || OriginalData?.approvalStatus === "Pending" && (
                <ul className="nav nav-tabs nav-tabs-card nav-tabs-xs w-100 p-0 m-0 position-relative">
                  <li className="nav-item" onClick={() => setDriverTab("1")}>
                    <a
                      onClick={(ev) => {
                        ev.preventDefault();
                      }}
                      className={`nav-link${driverTab === "1" ? " active" : ""
                        }`}
                      href="#driver-info"
                    >
                      General Info
                    </a>
                  </li>
                  <li className="nav-item" onClick={() => setDriverTab("2")}>
                    <a
                      href="#delivery-info"
                      onClick={(ev) => {
                        ev.preventDefault();
                      }}
                      className={`nav-link${driverTab === "2" ? " active" : ""
                        }`}
                    >
                      Delivery Info
                    </a>
                  </li>
                </ul>
              )}
              <div className="tab-content mt-0">
                {driverTab === "1" && (
                  <div className={`tab-pane${driverTab === "1" && " active"}`}>
                    <Col className="justify-start w-100 flex-wrap mt-3 p-3">
                      {/* Section 1: Basic Information */}
                      <div className="w-35 border-end">
                        <div className="data-col pt-1">
                          <div className="data-label">GRN Number</div>
                          <div className="data-value">
                            {OriginalData?.grnId ||
                              OriginalData?.grnSequenceId ||
                              "N/A"}
                          </div>
                        </div>
                        <div className="data-col pt-1">
                          <div className="data-label">GRN Date</div>
                          <div className="data-value">
                            {OriginalData?.grnCreatedDate ||
                              OriginalData?.mrnDate
                              ? dayjs(
                                OriginalData?.grnCreatedDate ||
                                OriginalData?.mrnDate
                              ).format("DD-MMM-YYYY")
                              : "N/A"}
                          </div>
                        </div>
                        <div className="data-col pt-1">
                          <div className="data-label">Gate Entry No.</div>
                          <div className="data-value">
                            {OriginalData?.gateEntryNo ||
                              OriginalData?.driverInfo?.gateEntryNo ||
                              "N/A"}
                          </div>
                        </div>
                        <div className="data-col pt-1">
                          <div className="data-label">Vehicle Type</div>
                          <div className="data-value">
                            {OriginalData?.driverInfo?.vehicleType || "N/A"}
                          </div>
                        </div>
                        <div className="data-col pt-1">
                          <div className="data-label">Vehicle Number</div>
                          <div className="data-value">
                            {OriginalData?.driverInfo?.vehicleNumber || "N/A"}
                          </div>
                        </div>
                        <div className="data-col pt-1">
                          <div className="data-label">Driver Name</div>
                          <div className="data-value">
                            {OriginalData?.driverInfo?.name || "N/A"}
                          </div>
                        </div>
                        <div className="data-col pt-1">
                          <div className="data-label">Email</div>
                          <div className="data-value">
                            {OriginalData?.driverInfo?.email || "N/A"}
                          </div>
                        </div>
                        <div className="data-col pt-1">
                          <div className="data-label">Mobile</div>
                          <div className="data-value">
                            {OriginalData?.driverInfo?.mobile || "N/A"}
                          </div>
                        </div>
                      </div>

                      {/* Section 2: Receipts & Documents */}
                      <div className="w-35 border-end paddingLeft10">
                        <div className="data-col pt-1">
                          <div
                            className="data-label"
                            style={{ marginBottom: "8px" }}
                          >
                            Vehicle InTime
                          </div>
                          <div
                            className="data-value"
                            style={{ marginLeft: "20px" }}
                          >
                            {OriginalData?.driverInfo?.vehicleInTime ||
                              OriginalData?.driverInfo?.inTime ||
                              "N/A"}
                          </div>
                        </div>
                        <div className="data-col pt-1">
                          <div
                            className="data-label"
                            style={{ marginBottom: "8px" }}
                          >
                            Vehicle OutTime
                          </div>
                          <div
                            className="data-value"
                            style={{ marginLeft: "20px" }}
                          >
                            {OriginalData?.driverInfo?.vehicleOutTime ||
                              OriginalData?.driverInfo?.outTime ||
                              "N/A"}
                          </div>
                        </div>
                        <div className="data-col pt-1">
                          <div
                            className="data-label"
                            style={{ marginBottom: "8px" }}
                          >
                            Dharamkanta Receipt No.
                          </div>
                          <div
                            className="data-value"
                            style={{ marginLeft: "20px" }}
                          >
                            {OriginalData?.driverInfo?.dharamKantaRecieptNo ||
                              OriginalData?.driverInfo?.dharamkantaReceiptNo ||
                              "N/A"}
                          </div>
                        </div>
                        <div className="data-col pt-1">
                          <div
                            className="data-label"
                            style={{ marginBottom: "8px" }}
                          >
                            DMR No.
                          </div>
                          <div
                            className="data-value"
                            style={{ marginLeft: "20px" }}
                          >
                            {OriginalData?.driverInfo?.dmrNo || "N/A"}
                          </div>
                        </div>
                        <div className="data-col pt-1">
                          <div
                            className="data-label"
                            style={{ marginBottom: "8px" }}
                          >
                            Weighbridge Slip No.
                          </div>
                          <div
                            className="data-value"
                            style={{ marginLeft: "20px" }}
                          >
                            {OriginalData?.driverInfo?.weighbridgeSlipNo ||
                              "N/A"}
                          </div>
                        </div>
                        <div className="data-col pt-1">
                          <div
                            className="data-label"
                            style={{ marginBottom: "8px" }}
                          >
                            Ticket No.
                          </div>
                          <div
                            className="data-value"
                            style={{ marginLeft: "20px" }}
                          >
                            {OriginalData?.driverInfo?.ticketNo || "N/A"}
                          </div>
                        </div>
                        <div className="data-col pt-1">
                          <div
                            className="data-label"
                            style={{ marginBottom: "8px" }}
                          >
                            YouTube Link
                          </div>
                          <div
                            className="data-value"
                            style={{
                              marginLeft: "20px",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              flexWrap: "wrap",
                            }}
                          >
                            {OriginalData?.driverInfo?.youTubeLink ||
                              OriginalData?.driverInfo?.youtubeLink ? (
                              <>
                                <Tooltip
                                  title={
                                    OriginalData?.driverInfo?.youTubeLink ||
                                    OriginalData?.driverInfo?.youtubeLink
                                  }
                                >
                                  <span
                                    style={{
                                      color: "#2263b3",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      e.nativeEvent.stopImmediatePropagation();
                                      const link =
                                        OriginalData?.driverInfo?.youTubeLink ||
                                        OriginalData?.driverInfo?.youtubeLink;
                                      if (link) {
                                        try {
                                          // Validate and format the URL
                                          let url = link.trim();

                                          // Check if it's already a valid URL
                                          if (
                                            !url.startsWith("http://") &&
                                            !url.startsWith("https://")
                                          ) {
                                            url = `https://${url}`;
                                          }

                                          // Validate URL format using URL constructor
                                          try {
                                            new URL(url);
                                            // URL is valid, open it
                                            window.open(
                                              url,
                                              "_blank",
                                              "noopener,noreferrer"
                                            );
                                          } catch (urlError) {
                                            // Invalid URL format - show error message
                                            message.error(
                                              "Invalid YouTube link format. Please check the link."
                                            );
                                            console.error("Invalid URL:", url);
                                          }
                                        } catch (error) {
                                          message.error(
                                            "Unable to open link. Please check if the link is valid."
                                          );
                                          console.error(
                                            "Error opening link:",
                                            error
                                          );
                                        }
                                      }
                                      return false;
                                    }}
                                    onMouseDown={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                    }}
                                  >
                                    View
                                  </span>
                                </Tooltip>
                                <Tooltip title="Copy link">
                                  <CopyOutlined
                                    style={{
                                      fontSize: "14px",
                                      color: "#2263b3",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      const link =
                                        OriginalData?.driverInfo?.youTubeLink ||
                                        OriginalData?.driverInfo?.youtubeLink;
                                      if (link) {
                                        copyToClipboard(link);
                                      }
                                      return false;
                                    }}
                                  />
                                </Tooltip>
                              </>
                            ) : (
                              "N/A"
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Section 3: Weights */}
                      <div className="w-30 paddingLeft10">
                        <div className="data-col pt-1">
                          <div
                            className="data-label"
                            style={{ marginBottom: "8px" }}
                          >
                            Load Truck Weight
                          </div>
                          <div
                            className="data-value"
                            style={{ marginLeft: "20px" }}
                          >
                            {OriginalData?.driverInfo?.loadTruckWeight
                              ? `${Number(
                                OriginalData?.driverInfo?.loadTruckWeight
                              ).toLocaleString()} TON`
                              : "N/A"}
                          </div>
                        </div>
                        <div className="data-col pt-1">
                          <div
                            className="data-label"
                            style={{ marginBottom: "8px" }}
                          >
                            Empty Truck Weight
                          </div>
                          <div
                            className="data-value"
                            style={{ marginLeft: "20px" }}
                          >
                            {OriginalData?.driverInfo?.emptyTruckWeight
                              ? `${Number(
                                OriginalData?.driverInfo?.emptyTruckWeight
                              ).toLocaleString()} TON`
                              : "N/A"}
                          </div>
                        </div>
                        <div className="data-col pt-1">
                          <div
                            className="data-label"
                            style={{ marginBottom: "8px" }}
                          >
                            Net Weight
                          </div>
                          <div
                            className="data-value"
                            style={{ marginLeft: "20px" }}
                          >
                            {OriginalData?.driverInfo?.netWeight
                              ? `${Number(
                                OriginalData?.driverInfo?.netWeight
                              ).toLocaleString()} TON`
                              : "N/A"}
                          </div>
                        </div>
                        <div className="data-col pt-1">
                          <div
                            className="data-label"
                            style={{
                              marginBottom: "8px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Load Truck Weight In House
                          </div>
                          <div
                            className="data-value"
                            style={{ marginLeft: "20px" }}
                          >
                            {OriginalData?.driverInfo?.loadTruckWeightInHouse
                              ? `${Number(
                                OriginalData?.driverInfo
                                  ?.loadTruckWeightInHouse
                              ).toLocaleString()} TON`
                              : "N/A"}
                          </div>
                        </div>
                        <div className="data-col pt-1">
                          <div
                            className="data-label"
                            style={{
                              marginBottom: "8px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Empty Truck Weight In House
                          </div>
                          <div
                            className="data-value"
                            style={{ marginLeft: "20px" }}
                          >
                            {OriginalData?.driverInfo?.emptyTruckWeightInHouse
                              ? `${Number(
                                OriginalData?.driverInfo
                                  ?.emptyTruckWeightInHouse
                              ).toLocaleString()} TON`
                              : "N/A"}
                          </div>
                        </div>
                        <div className="data-col pt-1">
                          <div
                            className="data-label"
                            style={{ marginBottom: "8px" }}
                          >
                            Net Weight In House
                          </div>
                          <div
                            className="data-value"
                            style={{ marginLeft: "20px" }}
                          >
                            {OriginalData?.driverInfo?.netWeightInHouse
                              ? `${Number(
                                OriginalData?.driverInfo?.netWeightInHouse
                              ).toLocaleString()} TON`
                              : "N/A"}
                          </div>
                        </div>

                        {/* Add Approvals field here - after Net Weight In House */}
                        <div className="data-col pt-1">
                          <div className="data-label">Approvals</div>
                          <div className="data-value" style={{ marginLeft: "20px" }}>
                            <ApprovalTimelineContent />
                          </div>
                        </div>
                      </div>
                    </Col>
                  </div>
                )}
                {driverTab === "2" && (
                  <div className={`tab-pane${driverTab === "2" && " active"}`}>
                    <Col className="justify-start w-100 flex-wrap p-0 mt-3">
                      <div className="w-40 paddingLeft10 border-end">
                        <div className="data-label mb-1">Billing Address</div>
                        <div className="data-value">
                          <ShowBillingAddress
                            type="billing"
                            address={materialData?.billingAddress}
                          />
                        </div>
                      </div>
                      {materialData?.deliveryAddressId && (
                        <div className="w-40 paddingLeft10">
                          <div className="data-label mb-1">
                            Delivery Address
                          </div>
                          <div className="data-value">
                            <ShowDeliveryAddress
                              type="delivery"
                              address={materialData?.deliveryAddress}
                            />
                          </div>
                        </div>
                      )}
                    </Col>
                  </div>
                )}
              </div>
            </Panel>
            <Panel header="Material Information" key="2">
              <div className="table-responsive poTable">
                <div
                  style={{
                    width: screenSize - 180 + "px",
                    margin: "auto",
                  }}
                >
                  <Form form={form} component={false}>
                    <Table
                      className="customTable"
                      components={{
                        body: {
                          cell: EditableCell,
                        },
                      }}
                      columns={mergedColumns.map((col: any) => {
                        if (col.key == "actions") {
                          return {
                            ...col,
                            hidden: readOnly,
                          };
                        }
                        return col;
                      })}
                      dataSource={dataSource.map((item: any) => ({
                        ...item,
                        quantityInvoiced: Number(item?.quantityInvoiced),
                        unitPrice: Number(item?.unitPrice),
                        key: item?.lineNo,
                      }))}
                      scroll={{ x: 1000 }}
                      expandable={{
                        expandedRowRender: (record: any) => (
                          <div className="expandableBody">
                            <div style={{ flex: 1, textAlign: "left" }}>
                              <p style={{ margin: 0 }}>{record.description}</p>
                              {record.file && (
                                <div>
                                  <PaperClipOutlined /> &nbsp;
                                  <a
                                    href={record?.file?.fileName}
                                    download={record?.file?.fileName}
                                  >
                                    {record?.file?.fileName}
                                  </a>
                                </div>
                              )}
                            </div>
                            {materialData?.deliveryAddressType ===
                              "Line Level" &&
                              record.deliveryAddressId && (
                                <div
                                  className="lineAddress"
                                  style={{ flex: 1 }}
                                >
                                  <h6>Delivery Address</h6>
                                  <ShowDeliveryAddress
                                    address={record.deliveryAddress}
                                  />
                                </div>
                              )}
                          </div>
                        ),
                      }}
                      bordered
                      size="middle"
                      pagination={false}
                    />
                  </Form>
                </div>
                {OriginalData?.grnId !== null && (
                  <Row className="m-4 justify-content-end ">
                    {grnSignature?.isActive && (
                      <div className="signatureBtnWrapper">
                        <div className="d-flex justify-content-between align-items-center">
                          <strong>Signature</strong>
                        </div>
                        <div
                          style={{
                            minHeight: grnSignature?.image ? "0px" : "120px",
                            display: grnSignature?.image ? "block" : "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {grnSignature?.image && (
                            <>
                              <div className="signatueImgWrapper border">
                                <img
                                  src={grnSignature?.image}
                                  alt="Signed"
                                  style={{ width: "160px" }}
                                />
                              </div>

                              <div>
                                <div className="form-group">
                                  <label
                                    className="form-label"
                                    htmlFor="signatureLabel"
                                  >
                                    Signature Label
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="signatureLabel"
                                    onChange={(e) => { }}
                                    disabled
                                    defaultValue={
                                      grnSignature?.label || "Authorised Signatory"
                                    }
                                  />
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </Row>
                )}
              </div>
              {OriginalData?.grnId == null && (
                <Row className="m-4 justify-content-end ">
                  {invoiceSignature?.isActive ? (
                    <div className="signatureBtnWrapper">
                      <div className="d-flex justify-content-between align-items-center">
                        <strong>Signature</strong>
                        <a
                          style={{
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setInvoiceSignature((prev: any) => ({
                              ...prev,
                              isActive: false,
                              image: null,
                              label: "Authorised Signatory",
                            }));
                            setValue("signatureObj", {
                              isActive: false,
                              image: null,
                              label: "Authorised Signatory",
                            });
                          }}
                        >
                          <Icon
                            name="cross"
                            className="pointer"
                            onClick={() => {
                              setInvoiceSignature((prev: any) => ({
                                ...prev,
                                isActive: false,
                                image: null,
                                label: "Authorised Signatory",
                              }));
                              setValue("signatureObj", {
                                isActive: false,
                                image: null,
                                label: "Authorised Signatory",
                              });
                            }}
                          />
                        </a>
                      </div>
                      <div
                        style={{
                          minHeight: invoiceSignature?.image ? "0px" : "120px",
                          display: invoiceSignature?.image ? "block" : "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {!invoiceSignature?.image && (
                          <Button
                            color="btn-dim btn"
                            onClick={() => {
                              setShowCropModel(true);
                            }}
                          >
                            <Icon
                              name="upload-cloud"
                              className="pointer"
                              onClick={() => {
                                setShowCropModel(true);
                              }}
                            />
                            <span>Upload</span>
                          </Button>
                        )}
                        {invoiceSignature?.image && (
                          <>
                            <div className="signatueImgWrapper border">
                              <img
                                src={invoiceSignature?.image}
                                alt="Signed"
                                style={{ width: "160px" }}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Button
                                color="btn-dim btn"
                                onClick={() => {
                                  setInvoiceSignature((pre: any) => {
                                    return { ...pre, image: null };
                                  });
                                }}
                              >
                                <span>Reset</span>
                                <Icon
                                  name="redo"
                                  className="pointer"
                                  onClick={() => {
                                    setInvoiceSignature((pre: any) => {
                                      return {
                                        ...pre,
                                        image: null,
                                      };
                                    });
                                  }}
                                />
                              </Button>
                            </div>
                            <div>
                              <div className="form-group">
                                <label
                                  className="form-label"
                                  htmlFor="signatureLabel"
                                >
                                  Signature Label
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="signatureLabel"
                                  onChange={(e) => {
                                    setInvoiceSignature((pre: any) => {
                                      return {
                                        ...pre,
                                        label: e.target.value,
                                      };
                                    });
                                  }}
                                  defaultValue={
                                    invoiceSignature?.label ||
                                    "Authorised Signatory"
                                  }
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </div>

                      {!invoiceSignature?.image && (
                        <>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              flexDirection: "column",
                            }}
                          >
                            <Button
                              color="btn-dim btn"
                              onClick={() => setShowSignatureModel(true)}
                            >
                              <Icon name="pen" />
                              <span>Use Signature Pad</span>
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  ) : (
                    <div
                      style={{
                        border: "1px solid #e5ecf7",
                        backgroundColor: "#f7faff",
                        padding: "10px",
                        marginLeft: "10px",
                        width: "22%",
                        borderRadius: "5px",
                        textAlign: "center",
                      }}
                    >
                      <Button
                        color="btn-dim btn"
                        onClick={() => {
                          setInvoiceSignature((pre: any) => {
                            return { ...pre, isActive: true };
                          });
                        }}
                      >
                        <Icon
                          name="edit"
                          className="pointer"
                          onClick={() => {
                            setInvoiceSignature((pre: any) => {
                              return { ...pre, isActive: true };
                            });
                          }}
                        />
                        <span>Add Signature</span>
                      </Button>
                    </div>
                  )}
                </Row>
              )}
            </Panel>
            <Panel header="Attachments" key="3">
              {/* Show existing attachments from server */}
              {attachments?.length > 0 && (
                <div style={{ marginBottom: "20px" }}>
                  <div className="data-label mb-2">Existing Attachments</div>
                  {attachments?.map((attachment: any, index: number) => (
                    <div
                      key={index}
                      className="w-100 d-flex justify-content-between mb-2"
                      style={{
                        padding: "8px",
                        border: "1px solid #e5ecf7",
                        borderRadius: "4px",
                      }}
                    >
                      <div>
                        <strong>{index + 1}.</strong>
                        &nbsp;
                        {attachment.name || attachment.fileName}
                        &nbsp; &nbsp; &nbsp; &nbsp;
                      </div>
                      <div>
                        <a
                          href={attachment.link || attachment.filePath}
                          download={attachment.name || attachment.fileName}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "black",
                            fontSize: "18px",
                          }}
                        >
                          <DownloadOutlined />
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Upload new attachments - only show if GRN is pending */}
              {OriginalData?.grnStatus === "Pending" && (
                <div>
                  {attachments?.length > 0 && (
                    <div className="data-label mb-2">Add New Attachments</div>
                  )}
                  <Dragger
                    beforeUpload={beforeUpload}
                    fileList={fileList}
                    onChange={handleAttachmentChange}
                    customRequest={customRequest}
                    className="ant-upload-drag-custom"
                    showUploadList={{ showPreviewIcon: false }}
                    itemRender={(originNode, file, fileList, actions) => {
                      // Customize the rendering of each file to remove the tooltip
                      return React.cloneElement(originNode, {
                        title: null, // Removes the tooltip entirely
                      });
                    }}
                  >
                    <p className="ant-upload-text">
                      Click or drag file to this area to upload
                    </p>
                  </Dragger>
                </div>
              )}

              {/* Show empty state only if no attachments and GRN is accepted */}
              {attachments?.length === 0 &&
                fileList.length === 0 &&
                OriginalData?.grnStatus === "Accepted" || OriginalData?.approvalStatus === "Pending" && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                    }}
                  >
                    <Empty description="No Attachments Available for the GRN" />
                  </div>
                )}
            </Panel>
          </AntCollapse>

          {showCropModel && (
            <CropperComponent
              modal={showCropModel}
              toggle={() => {
                setShowSignatureModel(false);
                if (activeSignatureContext === "APPROVE") {
                  setIsModalApproveVisible(true);
                } else if (activeSignatureContext === "REJECT") {
                  setIsModalRejectedVisible(true);
                }
              }}
              onSave={(data: string) => {
                setSignature((prev: any) => ({ ...prev, image: data }));
                setShowSignatureModel(false);

                if (activeSignatureContext === "APPROVE") {
                  setIsModalApproveVisible(true);
                } else if (activeSignatureContext === "REJECT") {
                  setIsModalRejectedVisible(true);
                }
              }}
            />
          )}
          {showSignatureModel && (
            <SignatureModal
              modal={showSignatureModel}
              toggle={() => {
                setShowSignatureModel(false);
                if (activeSignatureContext === "APPROVE") {
                  setIsModalApproveVisible(true);
                } else if (activeSignatureContext === "REJECT") {
                  setIsModalRejectedVisible(true);
                }
              }}
              onSave={(data: string) => {
                setSignature((prev: any) => ({ ...prev, image: data }));
                setShowSignatureModel(false);

                if (activeSignatureContext === "APPROVE") {
                  setIsModalApproveVisible(true);
                } else if (activeSignatureContext === "REJECT") {
                  setIsModalRejectedVisible(true);
                }
              }}
            />
          )}

          {showEmailModal && (
            <EmailCreationModal
              modal={showEmailModal}
              toggle={() => setShowEmailModal(!showEmailModal)}
              sendEmail={TriggerEmail}
              body={
                <div className="w-100 p-2">
                  <div className="m-auto">
                    <img
                      src={currentUser?.orgLogo}
                      alt={currentUser?.orgName}
                      width="200"
                      style={{ marginTop: "20px" }}
                    />

                    <div style={{ backgroundColor: "#fff", padding: "15px" }}>
                      {/* <h2 style={{ color: "#2263b3" }}>
                        Goods Receipt Confirmation
                      </h2> */}
                      <p style={{ color: "#1ee0ac", fontSize: "20px" }}>
                        Dear {OriginalData?.supplierName},
                      </p>
                      <p>
                        We are pleased to confirm that the goods/services
                        related to your delivery have been received and
                        acknowledged through a Goods Receipt Note (GRN) with ID{" "}
                        <strong>{OriginalData?.dispatchId}</strong>
                      </p>

                      <p>
                        <strong>GRN Summary:</strong>
                      </p>
                      <p>
                        <strong>GRN Number:</strong> {OriginalData?.dispatchId}
                        <br />
                        <strong>GRN Date:</strong>{" "}
                        {dayjs(OriginalData?.dispatchDate)?.format(
                          "DD-MMM-YYYY"
                        )}
                        <br />
                        <strong>Order Number:</strong> {OriginalData?.orderId}
                        <br />
                        <strong>Delivery Address:</strong>{" "}
                        {returnDispatchDetails()?.deliveryAddressString}
                        <br />
                      </p>

                      <p>
                        Please review the attached GRN document for full
                        details. If there are any discrepancies or questions
                        regarding the receipt, reach out to us promptly at{" "}
                        <a href={`mailto:{${currentUser?.email}}}`}>
                          {currentUser?.email}
                        </a>
                        .
                      </p>

                      <p>
                        This is an automatically generated email. Please do not
                        reply directly to this email.
                      </p>
                    </div>
                  </div>
                </div>
              }
              defaultAttachments={Object.assign({}, pdfBlobData.current, {
                name: OriginalData?.dispatchId + ".pdf",
                type: "application/pdf",
              })}
            />
          )}

          <AntModal
            title={undefined}
            visible={bankDetailsVisible}
            footer={null}
            onCancel={() => {
              setBankDetailsVisible(false);
            }}
            width="60%"
            bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
          >
            <ShowSupplierBankInfo />
          </AntModal>

          <AntModal
            title="Approve GRN"
            visible={isModalApproveVisible}
            onOk={() => {
              if (!signature.image) {
                Swal.fire({
                  icon: "info",
                  title: "Signature Required",
                  text: "Please add your signature before approving.",
                });
                return;
              }
              openApproveConfirmSwal();
            }}

            onCancel={() => {
              setIsModalApproveVisible(false);
              setSignature({ isActive: false, label: "Authorised Signatory", image: null });
            }}
            okText="Submit"
            cancelText="Cancel"
            width={600}
          >
            <div className="p-3">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <span style={{ fontSize: 14, fontWeight: 600 }}>Signature</span>

                {signature.image && (
                  <button
                    type="button"
                    onClick={() =>
                      setSignature({
                        isActive: true,
                        label: "Authorised Signatory",
                        image: null,
                      })
                    }
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      cursor: "pointer",
                    }}
                  >
                  </button>
                )}
              </div>

              {signature.image ? (
                <>
                  <div
                    className="border mb-3 d-flex justify-content-center align-items-center"
                    style={{
                      padding: 16,
                      borderRadius: 8,
                      background: "#fff",
                    }}
                  >
                    <img
                      src={signature.image}
                      alt="Signed"
                      style={{ maxWidth: 220, maxHeight: 120, objectFit: "contain" }}
                    />
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <Button
                      size="sm"
                      color="outline-secondary"
                      onClick={() =>
                        setSignature({
                          isActive: true,
                          label: "Authorised Signatory",
                          image: null,
                        })
                      }
                    >
                      Reset
                    </Button>
                  </div>
                </>
              ) : (
                <div
                  style={{
                    width: "100%",
                    minHeight: 220,
                    border: "2px dashed #dee2e6",
                    borderRadius: 8,
                    backgroundColor: "#f8f9fa",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 24,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: 12,
                      justifyContent: "center",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <ImageUploadCropper
                      onOpenCrop={() => setIsModalApproveVisible(false)}
                      onCloseCrop={() => setIsModalApproveVisible(true)}
                      onSave={(data: string) => {
                        setSignature((prev: any) => ({ ...prev, image: data }));
                      }}
                    >
                      <Button color="primary" size="sm" outline style={{ minWidth: 140 }} onClick={() => setActiveSignatureContext("APPROVE")}>
                        <Icon name="upload-cloud" className="me-1" />
                        Upload Image
                      </Button>
                    </ImageUploadCropper>

                    <Button
                      color="outline-primary"
                      size="sm"
                      style={{ minWidth: 140 }}
                      onClick={() => {
                        setIsModalApproveVisible(false);
                        setShowSignatureModel(true);
                      }}
                    >
                      <Icon name="pen" className="me-1" />
                      Signature Pad
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </AntModal >

          <AntModal
            title="Reject GRN"
            visible={isModalRejectedVisible}
            onOk={openRejectConfirmSwal}
            onCancel={() => {
              handleCancel();
              setSignature({ isActive: false, label: "Authorised Signatory", image: null });
            }}
            okText="Submit"
            cancelText="Cancel"
            width={600}
          >
            <Form form={form} layout="vertical" name="rejectForm">
              <Form.Item
                name="rejectedReason"
                label="Reason for Rejection"
                rules={[{ required: true, message: "Please input your reason!" }]}
              >
                <Input.TextArea rows={3} placeholder="Type your reason here..." />
              </Form.Item>

              <div className="mt-4">
                <strong style={{ fontSize: "16px" }}>Signature</strong>
              </div>

              {signature.image && (
                <a
                  style={{ fontSize: 14, cursor: "pointer" }}
                  onClick={() =>
                    setSignature({ isActive: true, label: "Authorised Signatory", image: null })
                  }
                >
                </a>
              )}


              {signature.image ? (
                <>
                  <div className="signatueImgWrapper border mb-3 p-3 text-center">
                    <img
                      src={signature.image}
                      alt="Signed"
                      style={{ width: "180px", height: "auto" }}
                    />
                  </div>
                  <div className="d-flex justify-content-end mb-3">
                    <Button
                      size="sm"
                      color="outline-secondary"
                      className="me-2"
                      onClick={() =>
                        setSignature({ isActive: true, label: "Authorised Signatory", image: null })
                      }
                    >
                      Reset
                    </Button>
                  </div>

                </>
              ) : (
                <div
                  style={{
                    minHeight: "200px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "15px",
                    border: "2px dashed #dee2e6",
                    borderRadius: "8px",
                    backgroundColor: "#f8f9fa"
                  }}
                >
                  <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", justifyContent: "center" }}>
                    <ImageUploadCropper
                      onOpenCrop={() => setIsModalRejectedVisible(false)}
                      onCloseCrop={() => setIsModalRejectedVisible(true)}
                      onSave={(data: string) => {
                        setSignature((prev: any) => ({ ...prev, image: data }));
                      }}
                    >
                      <Button color="primary" size="sm" outline onClick={() => setActiveSignatureContext("REJECT")}>
                        <Icon name="upload-cloud" className="me-1" />
                        Upload Image
                      </Button>
                    </ImageUploadCropper>

                    <Button
                      color="outline-primary"
                      size="sm"
                      onClick={() => {
                        setIsModalRejectedVisible(false);
                        setShowSignatureModel(true);
                      }}
                    >
                      <Icon name="pen" className="me-1" />
                      Signature Pad
                    </Button>
                  </div>
                </div>
              )}
            </Form>
          </AntModal>
        </div>
      )}
    </div>
  );
}
const ApproveCN = ({
  isModalVisible,
  setIsModalVisible,
  accept,
  extra,
  originalData,
  approvals = { open: false, data: [] },
  setApprovals,
  isStrictApproval = false,
  setIsStrictApproval,
  siteIdWatch,
}: any) => {
  const { showGrnId } = extra;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showMoreTransportFields, setShowMoreTransportFields] = useState(false);
  const [gateEntriesOptions, setGateEntriesOptions] = useState<any[]>([]);
  const [selectedGateEntry, setSelectedGateEntry] = useState<any>(null);
  const [isLoadingGateEntries, setIsLoadingGateEntries] = useState(false);
  const [grnSequenceAccess, setGrnSequenceAccess] = useState<{
    level: string;
    siteIds: string[];
  }>({ level: "", siteIds: [] });

  const methods = useForm<any>({
    mode: "onChange",
    defaultValues: {},
  });

  const {
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = methods;

  const autoRelease = watch("autoRelease");

  const vehicleTypeOptions = [
    { value: "tipper truck", label: "Tipper truck" },
    { value: "concrete truck", label: "Concrete truck" },
    { value: "pickup truck", label: "Pickup truck" },
    { value: "small truck", label: "Small truck" },
    { value: "box truck", label: "Box truck" },
    { value: "boat haulage", label: "Boat haulage" },
    { value: "flatbed truck", label: "Flatbed truck" },
    { value: "tow truck", label: "Tow truck" },
    { value: "chiller truck or reefers", label: "Chiller truck or reefers" },
    {
      value: "crane trucks or mobile cranes",
      label: "Crane trucks or mobile cranes",
    },
    { value: "logging truck", label: "Logging truck" },
    { value: "tanker truck", label: "Tanker truck" },
    { value: "furniture truck", label: "Furniture truck" },
    { value: "snow plows", label: "Snow plows" },
    { value: "trailer Truck", label: "Trailer Truck" },
    { value: "off-road Truck", label: "Off-road Truck" },
  ];

  const fetchGateEntries = async (siteId: number) => {
    if (!siteId) return;
    try {
      setIsLoadingGateEntries(true);
      const response = await invoiceApis.fetchGateEntriesDropDownBySiteId(
        siteId
      );
      // Handle different response structures
      const data = response?.data || response?.response?.data || response;
      if (Array.isArray(data) && data.length > 0) {
        const options = data.map((item: any) => ({
          label: item.gateEntryNumber || item.gateEntrySequenceId,
          value: item.gateEntryId,
          gateEntryId: item.gateEntryId,
          gateEntryNumber: item.gateEntryNumber,
        }));
        setGateEntriesOptions(options);
      } else {
        setGateEntriesOptions([]);
      }
    } catch (error) {
      console.log("Error fetching gate entries:", error);
      setGateEntriesOptions([]);
    } finally {
      setIsLoadingGateEntries(false);
    }
  };

  const fetchGrnSequenceStatus = async () => {
    try {
      const response = await sequenceApis.fetchSequenceByModuleId(8);
      const { data } = response;
      const today = new Date();
      // Check if sequence exists with:
      // 1. moduleId === 8 (GRN)
      // 2. status === "Active" (if "Active", hide GRN ID field)
      // 3. endDate is in the future
      const _sequenceAccess = data?.filter(
        (item: any) =>
          item.moduleId === 8 &&
          item.status === "Active" &&
          new Date(item.endDate) > today
      );
      if (_sequenceAccess?.length > 0) {
        setGrnSequenceAccess({
          level: _sequenceAccess[0].level || "",
          siteIds: _sequenceAccess
            ?.map((item: any) => item?.siteId?.toString())
            .filter(Boolean),
        });
      } else {
        setGrnSequenceAccess({ level: "", siteIds: [] });
      }
    } catch (error: any) {
      console.log(error.response?.data?.message || "An error occurred");
      setGrnSequenceAccess({ level: "", siteIds: [] });
    }
  };

  useEffect(() => {
    fetchGrnSequenceStatus();
  }, []);

  useEffect(() => {
    if (isModalVisible && originalData) {
      const driverInfo = originalData.driverInfo || {};
      // Helper function to convert time string to dayjs object
      const parseTime = (timeStr: string | undefined) => {
        if (!timeStr) return null;
        // Try to parse time string (format: "09:45 AM" or "09:45:00")
        try {
          const timeMatch = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);
          if (timeMatch) {
            let hours = parseInt(timeMatch[1]);
            const minutes = parseInt(timeMatch[2]);
            const period = timeMatch[3]?.toUpperCase();

            if (period === "PM" && hours !== 12) hours += 12;
            if (period === "AM" && hours === 12) hours = 0;

            return dayjs()
              .hour(hours)
              .minute(minutes)
              .second(0)
              .format("hh:mm A");
          }
          return null;
        } catch {
          return null;
        }
      };

      const grnDate = originalData.grnDate || originalData.mrnDate;

      setValue("grnId", originalData.grnId || originalData.grnSequenceId || "");
      setValue("grnCreatedDate", grnDate ? dayjs(grnDate).toDate() : null);
      setValue(
        "gateEntryId",
        originalData.gateEntryId || driverInfo.gateEntryId || ""
      );
      setValue("vehicleType", driverInfo.vehicleType || "");
      setValue("vehicleNumber", driverInfo.vehicleNumber || "");
      setValue("driverName", driverInfo.name || "");
      setValue("driverContact", driverInfo.mobile || "");
      setValue("driverEmail", driverInfo.email || "");
      setValue(
        "vehicleInTime",
        parseTime(driverInfo.vehicleInTime || driverInfo.inTime)
      );
      setValue("vehicleOutTime", parseTime(driverInfo.vehicleOutTime));
      setValue("dmrNo", driverInfo.dmrNo || "");
      setValue("ticketNo", driverInfo.ticketNo || "");
      setValue(
        "youTubeLink",
        driverInfo.youTubeLink || driverInfo.youtubeLink || ""
      );
      setValue(
        "dharamKantaRecieptNo",
        driverInfo.dharamKantaRecieptNo || driverInfo.dharamkantaReceiptNo || ""
      );
      setValue("weighbridgeSlipNo", driverInfo.weighbridgeSlipNo || "");
      setValue("loadTruckWeight", driverInfo.loadTruckWeight || "");
      setValue("emptyTruckWeight", driverInfo.emptyTruckWeight || "");
      setValue("netWeight", driverInfo.netWeight || "");
      setValue(
        "loadTruckWeightInHouse",
        driverInfo.loadTruckWeightInHouse || ""
      );
      setValue(
        "emptyTruckWeightInHouse",
        driverInfo.emptyTruckWeightInHouse || ""
      );
      setValue("netWeightInHouse", driverInfo.netWeightInHouse || "");

      // Fetch gate entries and sequence status in parallel when modal opens
      if (originalData?.siteId) {
        Promise.all([
          fetchGateEntries(Number(originalData.siteId)),
          fetchGrnSequenceStatus(),
        ]).catch((err) => console.log(err));
      } else {
        // Still refresh sequence status to honor org-level setup
        fetchGrnSequenceStatus().catch((err) => console.log(err));
      }
    }
    if (!isModalVisible) {
      setShowMoreTransportFields(false);
      setSelectedGateEntry(null);
      reset();
    }
  }, [isModalVisible, originalData, setValue, reset]);

  // Separate useEffect to set selected gate entry after options are loaded
  useEffect(() => {
    if (isModalVisible && originalData && gateEntriesOptions.length > 0) {
      const driverInfo = originalData.driverInfo || {};
      if (driverInfo.gateEntryId && !selectedGateEntry) {
        const gateEntry = gateEntriesOptions.find(
          (opt: any) => opt.gateEntryId === driverInfo.gateEntryId
        );
        if (gateEntry) {
          setSelectedGateEntry({
            gateEntryId: gateEntry.gateEntryId,
            gateEntryNumber: gateEntry.gateEntryNumber,
          });
          setValue("gateEntryId", gateEntry.gateEntryId);
        }
      }
    }
  }, [gateEntriesOptions, isModalVisible, originalData, setValue]);

  const handleCancel = () => {
    setIsModalVisible(false);
    setShowMoreTransportFields(false);
    setSelectedGateEntry(null);
    reset();
  };

  const onSubmit = (values: any) => {
    setIsSubmitting(true);
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, proceed!",
    }).then((result) => {
      if (result.isConfirmed) {
        const grnId = values?.grnId || "";
        const grnDate = values?.grnCreatedDate
          ? dayjs(values.grnCreatedDate).format("YYYY-MM-DD")
          : null;
        const driverInfo: any = {};

        // Map all form fields to driverInfo object structure
        if (values.driverName) driverInfo.name = values.driverName;
        if (values.dmrNo) driverInfo.dmrNo = values.dmrNo;
        if (values.driverEmail) driverInfo.email = values.driverEmail;
        if (values.driverContact) driverInfo.mobile = values.driverContact;
        if (values.ticketNo) driverInfo.ticketNo = values.ticketNo;
        if (
          values.netWeight !== undefined &&
          values.netWeight !== null &&
          values.netWeight !== ""
        )
          driverInfo.netWeight = values.netWeight;
        if (values.vehicleType) driverInfo.vehicleType = values.vehicleType;
        if (values.youTubeLink) driverInfo.youTubeLink = values.youTubeLink;
        if (values.vehicleInTime) {
          try {
            // FormTimePicker returns time in "hh:mm A" format, so we can use it directly
            driverInfo.vehicleInTime = values.vehicleInTime;
          } catch {
            driverInfo.vehicleInTime = values.vehicleInTime;
          }
        }
        if (values.vehicleNumber)
          driverInfo.vehicleNumber = values.vehicleNumber;
        if (values.vehicleOutTime) {
          try {
            // FormTimePicker returns time in "hh:mm A" format, so we can use it directly
            driverInfo.vehicleOutTime = values.vehicleOutTime;
          } catch {
            driverInfo.vehicleOutTime = values.vehicleOutTime;
          }
        }
        if (
          values.loadTruckWeight !== undefined &&
          values.loadTruckWeight !== null &&
          values.loadTruckWeight !== ""
        )
          driverInfo.loadTruckWeight = values.loadTruckWeight;
        if (
          values.emptyTruckWeight !== undefined &&
          values.emptyTruckWeight !== null &&
          values.emptyTruckWeight !== ""
        )
          driverInfo.emptyTruckWeight = values.emptyTruckWeight;
        if (
          values.netWeightInHouse !== undefined &&
          values.netWeightInHouse !== null &&
          values.netWeightInHouse !== ""
        )
          driverInfo.netWeightInHouse = values.netWeightInHouse;
        if (values.weighbridgeSlipNo)
          driverInfo.weighbridgeSlipNo = values.weighbridgeSlipNo;
        if (values.dharamKantaRecieptNo)
          driverInfo.dharamKantaRecieptNo = values.dharamKantaRecieptNo;
        if (
          values.loadTruckWeightInHouse !== undefined &&
          values.loadTruckWeightInHouse !== null &&
          values.loadTruckWeightInHouse !== ""
        )
          driverInfo.loadTruckWeightInHouse = values.loadTruckWeightInHouse;
        if (
          values.emptyTruckWeightInHouse !== undefined &&
          values.emptyTruckWeightInHouse !== null &&
          values.emptyTruckWeightInHouse !== ""
        )
          driverInfo.emptyTruckWeightInHouse = values.emptyTruckWeightInHouse;

        // Add gate entry information if selected
        if (
          selectedGateEntry?.gateEntryId !== undefined &&
          selectedGateEntry?.gateEntryId !== null
        ) {
          driverInfo.gateEntryId = selectedGateEntry.gateEntryId;
          // Also set gateEntryNo using the selected gate entry number
          if (
            selectedGateEntry?.gateEntryNumber !== undefined &&
            selectedGateEntry?.gateEntryNumber !== null
          ) {
            driverInfo.gateEntryNo = selectedGateEntry.gateEntryNumber;
          }
        }

        const autoRelease = values?.autoRelease === true;
        const grnApprovalHierarchy = approvals?.data || [];
        const strictApprovalBoolean = Boolean(isStrictApproval);

        accept(
          grnId,
          driverInfo,
          grnDate,
          selectedGateEntry?.gateEntryNumber || null,
          autoRelease,
          grnApprovalHierarchy,
          strictApprovalBoolean
        );
        reset();
        setIsModalVisible(false);
        setShowMoreTransportFields(false);
        setSelectedGateEntry(null);
        setIsSubmitting(false);
      } else {
        setIsSubmitting(false);
      }
    });
  };
  return (
    <Modal
      open={isModalVisible}
      footer={null}
      onCancel={handleCancel}
      width={1000}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className="mt-2">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <h6 style={{ margin: 0 }}>Transport Information</h6>
          </div>
          <div className="w-100">
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "16px",
                width: "100%",
              }}
            >
              {/* Initial 3 Fields */}
              {(() => {
                const siteId = originalData?.siteId
                  ? originalData?.siteId.toString()
                  : "";
                const level = grnSequenceAccess.level?.toLowerCase();

                const hideGrnId =
                  level === "organization" ||
                  level === "org" ||
                  (level === "site" &&
                    siteId &&
                    grnSequenceAccess.siteIds.includes(siteId));

                return !hideGrnId ? (
                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormInput
                      name="grnId"
                      label="GRN Number"
                      placeholder="GRN Number"
                      required
                    />
                  </div>
                ) : null;
              })()}

              <div
                style={{
                  flex: "1 1 calc(33.333% - 16px)",
                  minWidth: "250px",
                  marginBottom: "16px",
                }}
              >
                <FormDatePicker
                  name="grnCreatedDate"
                  label="GRN Date"
                  placeholder="GRN Date"
                  dateFormat="DD/MM/YYYY"
                  required
                />
              </div>

              <div
                style={{ flex: "1 1 calc(33.333% - 16px)", minWidth: "250px" }}
              >
                <div style={{ marginBottom: "16px" }}>
                  <FormSelect
                    name="gateEntryId"
                    label="Gate Entry No."
                    placeholder="Select Gate Entry"
                    required
                    options={gateEntriesOptions}
                    isLoading={isLoadingGateEntries}
                    onChange={(value: any, option: any) => {
                      if (option) {
                        const selectedOption = gateEntriesOptions.find(
                          (opt: any) => opt.value === value
                        );
                        if (selectedOption) {
                          setSelectedGateEntry({
                            gateEntryId: selectedOption.gateEntryId,
                            gateEntryNumber: selectedOption.gateEntryNumber,
                          });
                          // Also set gateEntryNumber in the form for reference
                          setValue(
                            "gateEntryNumber",
                            selectedOption.gateEntryNumber
                          );
                        }
                      } else {
                        setSelectedGateEntry(null);
                        setValue("gateEntryNumber", null);
                      }
                    }}
                  />
                </div>
              </div>

              {/* Row 2 */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-end",
                  width: "100%",
                  marginTop: "10px",
                }}
              >
                {/* Approval Required - Left */}
                <div style={{ width: "300px" }}>
                  <FormSelect
                    name="autoRelease"
                    label="Approval Required ?"
                    options={[
                      { label: "Yes", value: "true" },
                      { label: "No", value: "false" },
                    ]}
                    placeholder="Select"
                    required
                  />

                  <div style={{ display: "none" }}>
                    <FormInput name="approvalsData" label="" type="text" noMaxLength />
                  </div>

                  {autoRelease === "true" && (
                    <Popover
                      content="Click here to set required approvals"
                      title="Approval Required"
                    >
                      <a
                        href="#"
                        className="success"
                        onClick={(e) => {
                          e.preventDefault();
                          setApprovals((pre: any) => ({
                            ...pre,
                            open: true,
                          }));
                        }}
                      >
                        <EditOutlined /> Set Approvals{" "}
                        {approvals?.data?.length === 0 && (
                          <span className="mandatory">(Required)</span>
                        )}
                      </a>
                    </Popover>
                  )}
                </div>

                {/* Add More Button - Right */}
                <div>
                  <Button
                    type="button"
                    outline
                    style={{
                      backgroundColor: "transparent",
                      border: "1px solid #d0d0d0",
                      color: "#2263b3",
                    }}
                    onClick={() => setShowMoreTransportFields(!showMoreTransportFields)}
                  >
                    {showMoreTransportFields ? (
                      <Icon name="minus" />
                    ) : (
                      <>
                        <Icon name="plus-round" />
                        <span style={{ marginLeft: "6px" }}>Add More</span>
                      </>
                    )}
                  </Button>
                </div>
              </div>

            </div>

            {/* Additional Fields - Shown when "Add More" is clicked */}
            {showMoreTransportFields && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "16px",
                  width: "100%",
                  marginTop: "16px",
                }}
              >
                <>
                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormInput
                      name="vehicleNumber"
                      label={
                        <>
                          Vehicle Number {"("}
                          <span className="small"> eg: MH 12 AB 1234</span>{" "}
                          {")"}
                        </>
                      }
                      placeholder="Vehicle Number"
                    />
                  </div>

                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormInput
                      name="driverName"
                      label="Driver Name"
                      placeholder="Driver Name"
                    />
                  </div>

                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormInput
                      name="driverContact"
                      label="Driver Contact"
                      placeholder="Driver Contact"
                      type="text"
                      pattern="^[0-9]+$"
                      patternErrorMessage="Only numbers are allowed"
                      onKeyDown={(event: any) => {
                        if (
                          !/^[0-9]+$/.test(event.key) &&
                          ![
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ].includes(event.key)
                        ) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>

                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormSelect
                      name="vehicleType"
                      label="Vehicle Type"
                      placeholder="Select Vehicle Type"
                      options={vehicleTypeOptions}
                    />
                  </div>

                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormInput
                      name="driverEmail"
                      label="Driver Email"
                      placeholder="Driver Email"
                      type="email"
                      patternErrorMessage="Please enter a valid email address"
                    />
                  </div>

                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormInput
                      name="dharamKantaRecieptNo"
                      label="Dharamkanta Receipt No."
                      placeholder="Dharamkanta Receipt No."
                    />
                  </div>

                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormInput
                      name="dmrNo"
                      label="DMR No."
                      placeholder="DMR No."
                    />
                  </div>

                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormInput
                      name="weighbridgeSlipNo"
                      label="Weighbridge Slip No."
                      placeholder="Weighbridge Slip No."
                    />
                  </div>

                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormInput
                      name="ticketNo"
                      label="Ticket No."
                      placeholder="Ticket No."
                    />
                  </div>

                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormInput
                      name="youTubeLink"
                      label="You Tube link"
                      placeholder="You Tube link"
                    />
                  </div>

                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormInput
                      name="loadTruckWeight"
                      label="Load Truck Weight"
                      placeholder="Load Truck Weight"
                      type="number"
                      min={0}
                      onKeyDown={(event: any) => {
                        const regex = /^[0-9\b\.]+$/;
                        if (
                          !regex.test(event.key) &&
                          ![
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ].includes(event.key)
                        ) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>

                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormInput
                      name="emptyTruckWeight"
                      label="Empty Truck Weight"
                      placeholder="Empty Truck Weight"
                      type="number"
                      min={0}
                      onKeyDown={(event: any) => {
                        const regex = /^[0-9\b\.]+$/;
                        if (
                          !regex.test(event.key) &&
                          ![
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ].includes(event.key)
                        ) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>

                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormInput
                      name="netWeight"
                      label="Net Weight"
                      placeholder="Net Weight"
                      type="number"
                      min={0}
                      onKeyDown={(event: any) => {
                        const regex = /^[0-9\b\.]+$/;
                        if (
                          !regex.test(event.key) &&
                          ![
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ].includes(event.key)
                        ) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>

                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormTimePicker
                      name="vehicleInTime"
                      label="Vehicle InTime"
                      placeholder="Select Time"
                      format="hh:mm A"
                    />
                  </div>

                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormTimePicker
                      name="vehicleOutTime"
                      label="Vehicle OutTime"
                      placeholder="Select Time"
                      format="hh:mm A"
                    />
                  </div>

                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormInput
                      name="loadTruckWeightInHouse"
                      label="Load Truck Weight In House"
                      placeholder="Load Truck Weight"
                      type="number"
                      min={0}
                      onKeyDown={(event: any) => {
                        const regex = /^[0-9\b\.]+$/;
                        if (
                          !regex.test(event.key) &&
                          ![
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ].includes(event.key)
                        ) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>

                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormInput
                      name="emptyTruckWeightInHouse"
                      label="Empty Truck Weight In House"
                      placeholder="Empty Truck Weight"
                      type="number"
                      min={0}
                      onKeyDown={(event: any) => {
                        const regex = /^[0-9\b\.]+$/;
                        if (
                          !regex.test(event.key) &&
                          ![
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ].includes(event.key)
                        ) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>

                  <div
                    style={{
                      flex: "1 1 calc(33.333% - 16px)",
                      minWidth: "250px",
                      marginBottom: "16px",
                    }}
                  >
                    <FormInput
                      name="netWeightInHouse"
                      label="Net Weight In House"
                      placeholder="Net Weight"
                      type="number"
                      min={0}
                      onKeyDown={(event: any) => {
                        const regex = /^[0-9\b\.]+$/;
                        if (
                          !regex.test(event.key) &&
                          ![
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ].includes(event.key)
                        ) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>
                </>
              </div>
            )}
          </div>

          <div className="actions clearfix">
            <ul>
              <li>
                {isSubmitting ? (
                  <Button color="primary" type="button">
                    <Spinner size="sm" color="light" />
                  </Button>
                ) : (
                  <Button color="primary" type="submit">
                    Submit
                  </Button>
                )}
              </li>
              <li>
                <Button
                  color="primary"
                  onClick={handleCancel}
                  className="btn-dim btn btn-secondary"
                  type="button"
                >
                  Cancel
                </Button>
              </li>
            </ul>
          </div>
        </form>

        {approvals.open && (
          <GRNApprovalDrawer
            open={approvals.open}
            siteId={siteIdWatch}
            onClose={() => {
              setApprovals((pre: any) => {
                return {
                  ...pre,
                  open: false,
                };
              });
            }}
            onSubmit={(data: any, isStrictApprovalFromDrawer: boolean) => {
              setApprovals({
                open: false,
                data: data,
              });
              setIsStrictApproval(isStrictApprovalFromDrawer);
            }}
            initialStrictApproval={isStrictApproval}
            setApprovalSubmissionStatus={(status: boolean) => { }}
            approvalData={approvals.data}
          />
        )}
      </FormProvider>
    </Modal >
  );
};
export default ApprovalComponent;
